(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __markAsModule = (target) =>
    __defProp(target, "__esModule", { value: true });
  var __commonJS = (cb, mod) =>
    function __require() {
      return (
        mod ||
          (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod),
        mod.exports
      );
    };
  var __reExport = (target, module, desc) => {
    if (
      (module && typeof module === "object") ||
      typeof module === "function"
    ) {
      for (let key2 of __getOwnPropNames(module))
        if (!__hasOwnProp.call(target, key2) && key2 !== "default")
          __defProp(target, key2, {
            get: () => module[key2],
            enumerable:
              !(desc = __getOwnPropDesc(module, key2)) || desc.enumerable,
          });
    }
    return target;
  };
  var __toModule = (module) => {
    return __reExport(
      __markAsModule(
        __defProp(
          module != null ? __create(__getProtoOf(module)) : {},
          "default",
          module && module.__esModule && "default" in module
            ? { get: () => module.default, enumerable: true }
            : { value: module, enumerable: true }
        )
      ),
      module
    );
  };

  // node_modules/easytimer.js/dist/easytimer.js
  var require_easytimer = __commonJS({
    "node_modules/easytimer.js/dist/easytimer.js"(exports, module) {
      (function (global, factory) {
        typeof exports === "object" && typeof module !== "undefined"
          ? factory(exports)
          : typeof define === "function" && define.amd
          ? define(["exports"], factory)
          : ((global =
              typeof globalThis !== "undefined" ? globalThis : global || self),
            factory((global.easytimer = {})));
      })(exports, function (exports2) {
        "use strict";
        function ownKeys(e, r) {
          var t = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r &&
              (o = o.filter(function (r2) {
                return Object.getOwnPropertyDescriptor(e, r2).enumerable;
              })),
              t.push.apply(t, o);
          }
          return t;
        }
        function _objectSpread2(e) {
          for (var r = 1; r < arguments.length; r++) {
            var t = arguments[r] != null ? arguments[r] : {};
            r % 2
              ? ownKeys(Object(t), true).forEach(function (r2) {
                  _defineProperty(e, r2, t[r2]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
              : ownKeys(Object(t)).forEach(function (r2) {
                  Object.defineProperty(
                    e,
                    r2,
                    Object.getOwnPropertyDescriptor(t, r2)
                  );
                });
          }
          return e;
        }
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
                ? function (o2) {
                    return typeof o2;
                  }
                : function (o2) {
                    return o2 &&
                      typeof Symbol == "function" &&
                      o2.constructor === Symbol &&
                      o2 !== Symbol.prototype
                      ? "symbol"
                      : typeof o2;
                  }),
            _typeof(o)
          );
        }
        function _defineProperty(obj, key2, value) {
          key2 = _toPropertyKey(key2);
          if (key2 in obj) {
            Object.defineProperty(obj, key2, {
              value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key2] = value;
          }
          return obj;
        }
        function _toPrimitive(input, hint) {
          if (typeof input !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== void 0) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }
        function _toPropertyKey(arg) {
          var key2 = _toPrimitive(arg, "string");
          return typeof key2 === "symbol" ? key2 : String(key2);
        }
        function leftPadding(string, padLength, character) {
          var i;
          var characters = "";
          string = typeof string === "number" ? String(string) : string;
          if (string.length > padLength) {
            return string;
          }
          for (i = 0; i < padLength; i = i + 1) {
            characters += String(character);
          }
          return (characters + string).slice(-characters.length);
        }
        function TimeCounter() {
          this.reset();
        }
        TimeCounter.prototype.toString = function () {
          var units =
            arguments.length > 0 && arguments[0] !== void 0
              ? arguments[0]
              : ["hours", "minutes", "seconds"];
          var separator =
            arguments.length > 1 && arguments[1] !== void 0
              ? arguments[1]
              : ":";
          var leftZeroPadding =
            arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
          units = units || ["hours", "minutes", "seconds"];
          separator = separator || ":";
          leftZeroPadding = leftZeroPadding || 2;
          var arrayTime = [];
          var i;
          for (i = 0; i < units.length; i = i + 1) {
            if (this[units[i]] !== void 0) {
              if (units[i] === "secondTenths") {
                arrayTime.push(this[units[i]]);
              } else {
                arrayTime.push(
                  leftPadding(this[units[i]], leftZeroPadding, "0")
                );
              }
            }
          }
          return arrayTime.join(separator);
        };
        TimeCounter.prototype.reset = function () {
          this.secondTenths = 0;
          this.seconds = 0;
          this.minutes = 0;
          this.hours = 0;
          this.days = 0;
        };
        function EventEmitter() {
          this.events = {};
        }
        EventEmitter.prototype.on = function (event, listener) {
          var _this = this;
          if (!Array.isArray(this.events[event])) {
            this.events[event] = [];
          }
          this.events[event].push(listener);
          return function () {
            return _this.removeListener(event, listener);
          };
        };
        EventEmitter.prototype.removeListener = function (event, listener) {
          if (Array.isArray(this.events[event])) {
            var eventIndex = this.events[event].indexOf(listener);
            if (eventIndex > -1) {
              this.events[event].splice(eventIndex, 1);
            }
          }
        };
        EventEmitter.prototype.removeAllListeners = function (event) {
          if (!event) {
            this.events = {};
          } else if (Array.isArray(this.events[event])) {
            this.events[event] = [];
          }
        };
        EventEmitter.prototype.emit = function (event) {
          var _this2 = this;
          for (
            var _len = arguments.length,
              args = new Array(_len > 1 ? _len - 1 : 0),
              _key = 1;
            _key < _len;
            _key++
          ) {
            args[_key - 1] = arguments[_key];
          }
          if (Array.isArray(this.events[event])) {
            this.events[event].forEach(function (listener) {
              return listener.apply(_this2, args);
            });
          }
        };
        var SECOND_TENTHS_PER_SECOND = 10;
        var SECONDS_PER_MINUTE = 60;
        var MINUTES_PER_HOUR = 60;
        var HOURS_PER_DAY = 24;
        var SECOND_TENTHS_POSITION = 0;
        var SECONDS_POSITION = 1;
        var MINUTES_POSITION = 2;
        var HOURS_POSITION = 3;
        var DAYS_POSITION = 4;
        var SECOND_TENTHS = "secondTenths";
        var SECONDS = "seconds";
        var MINUTES = "minutes";
        var HOURS = "hours";
        var DAYS = "days";
        var VALID_INPUT_VALUES = [SECOND_TENTHS, SECONDS, MINUTES, HOURS, DAYS];
        var unitsInMilliseconds = {
          secondTenths: 100,
          seconds: 1e3,
          minutes: 6e4,
          hours: 36e5,
          days: 864e5,
        };
        var groupedUnits = {
          secondTenths: SECOND_TENTHS_PER_SECOND,
          seconds: SECONDS_PER_MINUTE,
          minutes: MINUTES_PER_HOUR,
          hours: HOURS_PER_DAY,
        };
        function mod(number, module2) {
          return ((number % module2) + module2) % module2;
        }
        function Timer2() {
          var defaultParams =
            arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var counters = new TimeCounter();
          var totalCounters = new TimeCounter();
          var intervalId;
          var eventEmitter = new EventEmitter();
          var running = false;
          var paused = false;
          var precision;
          var timerTypeFactor;
          var customCallback;
          var timerConfig = {};
          var currentParams;
          var targetValues;
          var startValues;
          var countdown;
          var startingDate;
          var targetDate;
          var eventData = {
            detail: {
              timer: this,
            },
          };
          setParams(defaultParams);
          function updateCounters(precision2, roundedValue) {
            var unitsPerGroup = groupedUnits[precision2];
            totalCounters[precision2] = roundedValue;
            if (precision2 === DAYS) {
              counters[precision2] = Math.abs(roundedValue);
            } else if (roundedValue >= 0) {
              counters[precision2] = mod(roundedValue, unitsPerGroup);
            } else {
              counters[precision2] = mod(
                unitsPerGroup - mod(roundedValue, unitsPerGroup),
                unitsPerGroup
              );
            }
          }
          function updateDays(value) {
            return updateUnitByPrecision(value, DAYS);
          }
          function updateHours(value) {
            return updateUnitByPrecision(value, HOURS);
          }
          function updateMinutes(value) {
            return updateUnitByPrecision(value, MINUTES);
          }
          function updateSeconds(value) {
            return updateUnitByPrecision(value, SECONDS);
          }
          function updateSecondTenths(value) {
            return updateUnitByPrecision(value, SECOND_TENTHS);
          }
          function updateUnitByPrecision(value, precision2) {
            var previousValue = totalCounters[precision2];
            updateCounters(
              precision2,
              calculateIntegerUnitQuotient(
                value,
                unitsInMilliseconds[precision2]
              )
            );
            return totalCounters[precision2] !== previousValue;
          }
          function stopTimerAndResetCounters() {
            stopTimer();
            resetCounters();
          }
          function stopTimer() {
            clearInterval(intervalId);
            intervalId = void 0;
            running = false;
            paused = false;
          }
          function setParamsAndStartTimer(params) {
            if (!isPaused()) {
              setParams(params);
            } else {
              startingDate = calculateStartingDate();
              targetValues = setTarget(currentParams.target);
            }
            startTimer();
          }
          function startTimer() {
            var interval = unitsInMilliseconds[precision];
            if (isTargetAchieved(roundTimestamp(Date.now()))) {
              return;
            }
            intervalId = setInterval(updateTimerAndDispatchEvents, interval);
            running = true;
            paused = false;
          }
          function calculateStartingDate() {
            return (
              roundTimestamp(Date.now()) -
              totalCounters.secondTenths *
                unitsInMilliseconds[SECOND_TENTHS] *
                timerTypeFactor
            );
          }
          function updateTimerAndDispatchEvents() {
            var currentTime = roundTimestamp(Date.now());
            var valuesUpdated = updateTimer();
            dispatchEvents(valuesUpdated);
            customCallback(eventData.detail.timer);
            if (isTargetAchieved(currentTime)) {
              stop();
              dispatchEvent("targetAchieved", eventData);
            }
          }
          function updateTimer() {
            var currentTime =
              arguments.length > 0 && arguments[0] !== void 0
                ? arguments[0]
                : roundTimestamp(Date.now());
            var elapsedTime =
              timerTypeFactor > 0
                ? currentTime - startingDate
                : startingDate - currentTime;
            var valuesUpdated = {};
            valuesUpdated[SECOND_TENTHS] = updateSecondTenths(elapsedTime);
            valuesUpdated[SECONDS] = updateSeconds(elapsedTime);
            valuesUpdated[MINUTES] = updateMinutes(elapsedTime);
            valuesUpdated[HOURS] = updateHours(elapsedTime);
            valuesUpdated[DAYS] = updateDays(elapsedTime);
            return valuesUpdated;
          }
          function roundTimestamp(timestamp) {
            return (
              Math.floor(timestamp / unitsInMilliseconds[precision]) *
              unitsInMilliseconds[precision]
            );
          }
          function dispatchEvents(valuesUpdated) {
            if (valuesUpdated[SECOND_TENTHS]) {
              dispatchEvent("secondTenthsUpdated", eventData);
            }
            if (valuesUpdated[SECONDS]) {
              dispatchEvent("secondsUpdated", eventData);
            }
            if (valuesUpdated[MINUTES]) {
              dispatchEvent("minutesUpdated", eventData);
            }
            if (valuesUpdated[HOURS]) {
              dispatchEvent("hoursUpdated", eventData);
            }
            if (valuesUpdated[DAYS]) {
              dispatchEvent("daysUpdated", eventData);
            }
          }
          function isTargetAchieved(currentDate) {
            return targetValues instanceof Array && currentDate >= targetDate;
          }
          function resetCounters() {
            counters.reset();
            totalCounters.reset();
          }
          function setParams(params) {
            params = params || {};
            precision = checkPrecision(params.precision);
            customCallback =
              typeof params.callback === "function"
                ? params.callback
                : function () {};
            countdown = params.countdown === true;
            timerTypeFactor = countdown === true ? -1 : 1;
            if (_typeof(params.startValues) === "object") {
              setStartValues(params.startValues);
            } else {
              startValues = null;
            }
            startingDate = calculateStartingDate();
            updateTimer();
            if (_typeof(params.target) === "object") {
              targetValues = setTarget(params.target);
            } else if (countdown) {
              params.target = {
                seconds: 0,
              };
              targetValues = setTarget(params.target);
            } else {
              targetValues = null;
            }
            timerConfig = {
              precision,
              callback: customCallback,
              countdown:
                _typeof(params) === "object" && params.countdown === true,
              target: targetValues,
              startValues,
            };
            currentParams = params;
          }
          function checkPrecision(precision2) {
            precision2 = typeof precision2 === "string" ? precision2 : SECONDS;
            if (!isValidInputValue(precision2)) {
              throw new Error(
                "Error in precision parameter: ".concat(
                  precision2,
                  " is not a valid value"
                )
              );
            }
            return precision2;
          }
          function isValidInputValue(value) {
            return VALID_INPUT_VALUES.indexOf(value) >= 0;
          }
          function configInputValues(inputValues) {
            var values;
            if (_typeof(inputValues) === "object") {
              if (inputValues instanceof Array) {
                if (inputValues.length !== 5) {
                  throw new Error("Array size not valid");
                }
                values = inputValues;
              } else {
                for (var value in inputValues) {
                  if (VALID_INPUT_VALUES.indexOf(value) < 0) {
                    throw new Error(
                      "Error in startValues or target parameter: ".concat(
                        value,
                        " is not a valid input value"
                      )
                    );
                  }
                }
                values = [
                  inputValues.secondTenths || 0,
                  inputValues.seconds || 0,
                  inputValues.minutes || 0,
                  inputValues.hours || 0,
                  inputValues.days || 0,
                ];
              }
            }
            values = values.map(function (value2) {
              return parseInt(value2, 10);
            });
            var secondTenths = values[SECOND_TENTHS_POSITION];
            var seconds =
              values[SECONDS_POSITION] +
              calculateIntegerUnitQuotient(
                secondTenths,
                SECOND_TENTHS_PER_SECOND
              );
            var minutes =
              values[MINUTES_POSITION] +
              calculateIntegerUnitQuotient(seconds, SECONDS_PER_MINUTE);
            var hours =
              values[HOURS_POSITION] +
              calculateIntegerUnitQuotient(minutes, MINUTES_PER_HOUR);
            var days =
              values[DAYS_POSITION] +
              calculateIntegerUnitQuotient(hours, HOURS_PER_DAY);
            values[SECOND_TENTHS_POSITION] =
              secondTenths % SECOND_TENTHS_PER_SECOND;
            values[SECONDS_POSITION] = seconds % SECONDS_PER_MINUTE;
            values[MINUTES_POSITION] = minutes % MINUTES_PER_HOUR;
            values[HOURS_POSITION] = hours % HOURS_PER_DAY;
            values[DAYS_POSITION] = days;
            return values;
          }
          function calculateIntegerUnitQuotient(unit, divisor) {
            var quotient = unit / divisor;
            return quotient < 0 ? Math.ceil(quotient) : Math.floor(quotient);
          }
          function setTarget(inputTarget) {
            if (!inputTarget) {
              return;
            }
            targetValues = configInputValues(inputTarget);
            var targetCounter = calculateTotalCounterFromValues(targetValues);
            targetDate =
              startingDate +
              targetCounter.secondTenths *
                unitsInMilliseconds[SECOND_TENTHS] *
                timerTypeFactor;
            return targetValues;
          }
          function setStartValues(inputStartValues) {
            startValues = configInputValues(inputStartValues);
            counters.secondTenths = startValues[SECOND_TENTHS_POSITION];
            counters.seconds = startValues[SECONDS_POSITION];
            counters.minutes = startValues[MINUTES_POSITION];
            counters.hours = startValues[HOURS_POSITION];
            counters.days = startValues[DAYS_POSITION];
            totalCounters = calculateTotalCounterFromValues(
              startValues,
              totalCounters
            );
          }
          function calculateTotalCounterFromValues(values, outputCounter) {
            var total = outputCounter || {};
            total.days = values[DAYS_POSITION];
            total.hours = total.days * HOURS_PER_DAY + values[HOURS_POSITION];
            total.minutes =
              total.hours * MINUTES_PER_HOUR + values[MINUTES_POSITION];
            total.seconds =
              total.minutes * SECONDS_PER_MINUTE + values[SECONDS_POSITION];
            total.secondTenths =
              total.seconds * SECOND_TENTHS_PER_SECOND +
              values[[SECOND_TENTHS_POSITION]];
            return total;
          }
          function stop() {
            stopTimerAndResetCounters();
            dispatchEvent("stopped", eventData);
          }
          function reset() {
            stopTimerAndResetCounters();
            setParamsAndStartTimer(currentParams);
            dispatchEvent("reset", eventData);
          }
          function start() {
            var params =
              arguments.length > 0 && arguments[0] !== void 0
                ? arguments[0]
                : {};
            params = _objectSpread2(_objectSpread2({}, defaultParams), params);
            if (isRunning()) {
              return;
            }
            setParamsAndStartTimer(params);
            dispatchEvent("started", eventData);
          }
          function pause() {
            stopTimer();
            paused = true;
            dispatchEvent("paused", eventData);
          }
          function addEventListener(eventType, listener) {
            eventEmitter.on(eventType, listener);
          }
          function removeEventListener(eventType, listener) {
            eventEmitter.removeListener(eventType, listener);
          }
          function removeAllEventListeners(eventType) {
            eventEmitter.removeAllListeners(eventType);
          }
          function dispatchEvent(eventType, data) {
            eventEmitter.emit(eventType, data);
          }
          function isRunning() {
            return running;
          }
          function isPaused() {
            return paused;
          }
          function getTimeValues() {
            return counters;
          }
          function getTotalTimeValues() {
            return totalCounters;
          }
          function getConfig() {
            return timerConfig;
          }
          if (typeof this !== "undefined") {
            this.start = start;
            this.pause = pause;
            this.stop = stop;
            this.reset = reset;
            this.isRunning = isRunning;
            this.isPaused = isPaused;
            this.getTimeValues = getTimeValues;
            this.getTotalTimeValues = getTotalTimeValues;
            this.getConfig = getConfig;
            this.addEventListener = addEventListener;
            this.on = addEventListener;
            this.removeEventListener = removeEventListener;
            this.removeAllEventListeners = removeAllEventListeners;
            this.off = removeEventListener;
          }
        }
        exports2.Timer = Timer2;
        exports2.default = Timer2;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    },
  });

  // node_modules/zenscroll/zenscroll.js
  var require_zenscroll = __commonJS({
    "node_modules/zenscroll/zenscroll.js"(exports, module) {
      (function (root, factory) {
        if (typeof define === "function" && define.amd) {
          define([], factory());
        } else if (typeof module === "object" && module.exports) {
          module.exports = factory();
        } else {
          (function install() {
            if (document && document.body) {
              root.zenscroll = factory();
            } else {
              setTimeout(install, 9);
            }
          })();
        }
      })(exports, function () {
        "use strict";
        var isNativeSmoothScrollEnabledOn = function (elem) {
          return (
            elem &&
            "getComputedStyle" in window &&
            window.getComputedStyle(elem)["scroll-behavior"] === "smooth"
          );
        };
        if (typeof window === "undefined" || !("document" in window)) {
          return {};
        }
        var makeScroller = function (container, defaultDuration, edgeOffset) {
          defaultDuration = defaultDuration || 999;
          if (!edgeOffset && edgeOffset !== 0) {
            edgeOffset = 9;
          }
          var scrollTimeoutId;
          var setScrollTimeoutId = function (newValue) {
            scrollTimeoutId = newValue;
          };
          var stopScroll = function () {
            clearTimeout(scrollTimeoutId);
            setScrollTimeoutId(0);
          };
          var getTopWithEdgeOffset = function (elem) {
            return Math.max(0, container.getTopOf(elem) - edgeOffset);
          };
          var scrollToY = function (targetY, duration, onDone) {
            stopScroll();
            if (
              duration === 0 ||
              (duration && duration < 0) ||
              isNativeSmoothScrollEnabledOn(container.body)
            ) {
              container.toY(targetY);
              if (onDone) {
                onDone();
              }
            } else {
              var startY = container.getY();
              var distance = Math.max(0, targetY) - startY;
              var startTime = new Date().getTime();
              duration =
                duration || Math.min(Math.abs(distance), defaultDuration);
              (function loopScroll() {
                setScrollTimeoutId(
                  setTimeout(function () {
                    var p = Math.min(
                      1,
                      (new Date().getTime() - startTime) / duration
                    );
                    var y = Math.max(
                      0,
                      Math.floor(
                        startY +
                          distance * (p < 0.5 ? 2 * p * p : p * (4 - p * 2) - 1)
                      )
                    );
                    container.toY(y);
                    if (
                      p < 1 &&
                      container.getHeight() + y < container.body.scrollHeight
                    ) {
                      loopScroll();
                    } else {
                      setTimeout(stopScroll, 99);
                      if (onDone) {
                        onDone();
                      }
                    }
                  }, 9)
                );
              })();
            }
          };
          var scrollToElem = function (elem, duration, onDone) {
            scrollToY(getTopWithEdgeOffset(elem), duration, onDone);
          };
          var scrollIntoView = function (elem, duration, onDone) {
            var elemHeight = elem.getBoundingClientRect().height;
            var elemBottom = container.getTopOf(elem) + elemHeight;
            var containerHeight = container.getHeight();
            var y = container.getY();
            var containerBottom = y + containerHeight;
            if (
              getTopWithEdgeOffset(elem) < y ||
              elemHeight + edgeOffset > containerHeight
            ) {
              scrollToElem(elem, duration, onDone);
            } else if (elemBottom + edgeOffset > containerBottom) {
              scrollToY(
                elemBottom - containerHeight + edgeOffset,
                duration,
                onDone
              );
            } else if (onDone) {
              onDone();
            }
          };
          var scrollToCenterOf = function (elem, duration, offset, onDone) {
            scrollToY(
              Math.max(
                0,
                container.getTopOf(elem) -
                  container.getHeight() / 2 +
                  (offset || elem.getBoundingClientRect().height / 2)
              ),
              duration,
              onDone
            );
          };
          var setup = function (newDefaultDuration, newEdgeOffset) {
            if (newDefaultDuration === 0 || newDefaultDuration) {
              defaultDuration = newDefaultDuration;
            }
            if (newEdgeOffset === 0 || newEdgeOffset) {
              edgeOffset = newEdgeOffset;
            }
            return {
              defaultDuration,
              edgeOffset,
            };
          };
          return {
            setup,
            to: scrollToElem,
            toY: scrollToY,
            intoView: scrollIntoView,
            center: scrollToCenterOf,
            stop: stopScroll,
            moving: function () {
              return !!scrollTimeoutId;
            },
            getY: container.getY,
            getTopOf: container.getTopOf,
          };
        };
        var docElem = document.documentElement;
        var getDocY = function () {
          return window.scrollY || docElem.scrollTop;
        };
        var zenscroll2 = makeScroller({
          body: document.scrollingElement || document.body,
          toY: function (y) {
            window.scrollTo(0, y);
          },
          getY: getDocY,
          getHeight: function () {
            return window.innerHeight || docElem.clientHeight;
          },
          getTopOf: function (elem) {
            return (
              elem.getBoundingClientRect().top + getDocY() - docElem.offsetTop
            );
          },
        });
        zenscroll2.createScroller = function (
          scrollContainer,
          defaultDuration,
          edgeOffset
        ) {
          return makeScroller(
            {
              body: scrollContainer,
              toY: function (y) {
                scrollContainer.scrollTop = y;
              },
              getY: function () {
                return scrollContainer.scrollTop;
              },
              getHeight: function () {
                return Math.min(
                  scrollContainer.clientHeight,
                  window.innerHeight || docElem.clientHeight
                );
              },
              getTopOf: function (elem) {
                return elem.offsetTop;
              },
            },
            defaultDuration,
            edgeOffset
          );
        };
        if (
          "addEventListener" in window &&
          !window.noZensmooth &&
          !isNativeSmoothScrollEnabledOn(document.body)
        ) {
          var isHistorySupported =
            "history" in window && "pushState" in history;
          var isScrollRestorationSupported =
            isHistorySupported && "scrollRestoration" in history;
          if (isScrollRestorationSupported) {
            history.scrollRestoration = "auto";
          }
          window.addEventListener(
            "load",
            function () {
              if (isScrollRestorationSupported) {
                setTimeout(function () {
                  history.scrollRestoration = "manual";
                }, 9);
                window.addEventListener(
                  "popstate",
                  function (event) {
                    if (event.state && "zenscrollY" in event.state) {
                      zenscroll2.toY(event.state.zenscrollY);
                    }
                  },
                  false
                );
              }
              if (window.location.hash) {
                setTimeout(function () {
                  var edgeOffset = zenscroll2.setup().edgeOffset;
                  if (edgeOffset) {
                    var targetElem = document.getElementById(
                      window.location.href.split("#")[1]
                    );
                    if (targetElem) {
                      var targetY = Math.max(
                        0,
                        zenscroll2.getTopOf(targetElem) - edgeOffset
                      );
                      var diff = zenscroll2.getY() - targetY;
                      if (0 <= diff && diff < 9) {
                        window.scrollTo(0, targetY);
                      }
                    }
                  }
                }, 9);
              }
            },
            false
          );
          var RE_noZensmooth = new RegExp("(^|\\s)noZensmooth(\\s|$)");
          window.addEventListener(
            "click",
            function (event) {
              var anchor = event.target;
              while (anchor && anchor.tagName !== "A") {
                anchor = anchor.parentNode;
              }
              if (
                !anchor ||
                event.which !== 1 ||
                event.shiftKey ||
                event.metaKey ||
                event.ctrlKey ||
                event.altKey
              ) {
                return;
              }
              if (isScrollRestorationSupported) {
                var historyState =
                  history.state && typeof history.state === "object"
                    ? history.state
                    : {};
                historyState.zenscrollY = zenscroll2.getY();
                try {
                  history.replaceState(historyState, "");
                } catch (e) {}
              }
              var href = anchor.getAttribute("href") || "";
              if (
                href.indexOf("#") === 0 &&
                !RE_noZensmooth.test(anchor.className)
              ) {
                var targetY = 0;
                var targetElem = document.getElementById(href.substring(1));
                if (href !== "#") {
                  if (!targetElem) {
                    return;
                  }
                  targetY = zenscroll2.getTopOf(targetElem);
                }
                event.preventDefault();
                var onDone = function () {
                  window.location = href;
                };
                var edgeOffset = zenscroll2.setup().edgeOffset;
                if (edgeOffset) {
                  targetY = Math.max(0, targetY - edgeOffset);
                  if (isHistorySupported) {
                    onDone = function () {
                      history.pushState({}, "", href);
                    };
                  }
                }
                zenscroll2.toY(targetY, null, onDone);
              }
            },
            false
          );
        }
        return zenscroll2;
      });
    },
  });

  // node_modules/@shopify/theme-sections/section.js
  var SECTION_ID_ATTR = "data-section-id";
  function Section(container, properties2) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];
    Object.assign(this, validatePropertiesObject(properties2));
    this.onLoad();
  }
  Section.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function extend(extension) {
      this.extensions.push(extension);
      var extensionClone = Object.assign({}, extension);
      delete extensionClone.init;
      Object.assign(this, extensionClone);
      if (typeof extension.init === "function") {
        extension.init.apply(this);
      }
    },
  };
  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError(
        "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
      );
    }
    if (container.getAttribute(SECTION_ID_ATTR) === null) {
      throw new Error(
        "Theme Sections: The section container provided does not have an id assigned to the " +
          SECTION_ID_ATTR +
          " attribute."
      );
    }
    return container;
  }
  function validatePropertiesObject(value) {
    if (
      (typeof value !== "undefined" && typeof value !== "object") ||
      value === null
    ) {
      throw new TypeError(
        "Theme Sections: The properties object provided is not a valid"
      );
    }
    return value;
  }
  if (typeof Object.assign != "function") {
    Object.defineProperty(Object, "assign", {
      value: function assign(target) {
        "use strict";
        if (target == null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true,
    });
  }

  // node_modules/@shopify/theme-sections/theme-sections.js
  var SECTION_TYPE_ATTR = "data-section-type";
  var SECTION_ID_ATTR2 = "data-section-id";
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};
  var registered = (window.Shopify.theme.sections.registered =
    window.Shopify.theme.sections.registered || {});
  var instances = (window.Shopify.theme.sections.instances =
    window.Shopify.theme.sections.instances || []);
  function register(type, properties2) {
    if (typeof type !== "string") {
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    }
    if (typeof registered[type] !== "undefined") {
      throw new Error(
        'Theme Sections: A section of type "' +
          type +
          '" has already been registered. You cannot register the same section type twice'
      );
    }
    function TypedSection(container) {
      Section.call(this, container, properties2);
    }
    TypedSection.constructor = Section;
    TypedSection.prototype = Object.create(Section.prototype);
    TypedSection.prototype.type = type;
    return (registered[type] = TypedSection);
  }
  function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === "undefined") {
      containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
    }
    containers = normalizeContainers(containers);
    types.forEach(function (type) {
      var TypedSection = registered[type];
      if (typeof TypedSection === "undefined") {
        return;
      }
      containers = containers.filter(function (container) {
        if (isInstance(container)) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
          return true;
        }
        instances.push(new TypedSection(container));
        return false;
      });
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function (instance) {
      var index = instances
        .map(function (e) {
          return e.id;
        })
        .indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function (container) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function (instance) {
            return instance.container === container;
          })
        );
      });
    } else if (
      typeof selector === "string" ||
      typeof firstElement === "string"
    ) {
      var types = normalizeType(selector);
      types.forEach(function (type) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function (instance) {
            return instance.type === type;
          })
        );
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id2) {
    var instance;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id2) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    if (types === "*") {
      types = Object.keys(registered);
    } else if (typeof types === "string") {
      types = [types];
    } else if (types.constructor === Section) {
      types = [types.prototype.type];
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function (TypedSection) {
        return TypedSection.prototype.type;
      });
    }
    types = types.map(function (type) {
      return type.toLowerCase();
    });
    return types;
  }
  function normalizeContainers(containers) {
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);
    } else if (
      NodeList.prototype.isPrototypeOf(containers) &&
      containers.length === 0
    ) {
      containers = [];
    } else if (containers === null) {
      containers = [];
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }
    return containers;
  }
  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      var id2 = event.detail.sectionId;
      var container = event.target.querySelector(
        "[" + SECTION_ID_ATTR2 + '="' + id2 + '"]'
      );
      if (container !== null) {
        load(container.getAttribute(SECTION_TYPE_ATTR), container);
      }
    });
    document.addEventListener("shopify:section:unload", function (event) {
      var id2 = event.detail.sectionId;
      var container = event.target.querySelector(
        "[" + SECTION_ID_ATTR2 + '="' + id2 + '"]'
      );
      var instance = getInstances(container)[0];
      if (typeof instance === "object") {
        unload(container);
      }
    });
    document.addEventListener("shopify:section:select", function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onSelect(event);
      }
    });
    document.addEventListener("shopify:section:deselect", function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onDeselect(event);
      }
    });
    document.addEventListener("shopify:block:select", function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockSelect(event);
      }
    });
    document.addEventListener("shopify:block:deselect", function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockDeselect(event);
      }
    });
  }

  // node_modules/tiny-slider/src/helpers/raf.js
  var win = window;
  var raf =
    win.requestAnimationFrame ||
    win.webkitRequestAnimationFrame ||
    win.mozRequestAnimationFrame ||
    win.msRequestAnimationFrame ||
    function (cb) {
      return setTimeout(cb, 16);
    };

  // node_modules/tiny-slider/src/helpers/caf.js
  var win2 = window;
  var caf =
    win2.cancelAnimationFrame ||
    win2.mozCancelAnimationFrame ||
    function (id2) {
      clearTimeout(id2);
    };

  // node_modules/tiny-slider/src/helpers/docElement.js
  var docElement = document.documentElement;

  // node_modules/tiny-slider/src/helpers/classListSupport.js
  var classListSupport = "classList" in document.createElement("_");

  // node_modules/tiny-slider/src/helpers/passiveOption.js
  var supportsPassive = false;
  try {
    opts = Object.defineProperty({}, "passive", {
      get: function () {
        supportsPassive = true;
      },
    });
    window.addEventListener("test", null, opts);
  } catch (e) {}
  var opts;

  // node_modules/tiny-slider/src/tiny-slider.js
  if (!Object.keys) {
    Object.keys = function (object) {
      var keys = [];
      for (var name in object) {
        if (Object.prototype.hasOwnProperty.call(object, name)) {
          keys.push(name);
        }
      }
      return keys;
    };
  }
  if (!("remove" in Element.prototype)) {
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }

  // app/scripts/common/_arn.js
  var import_easytimer = __toModule(require_easytimer());

  // node_modules/@shopify/theme-product-form/listeners.js
  function Listeners() {
    this.entries = [];
  }
  Listeners.prototype.add = function (element, event, fn) {
    this.entries.push({ element, event, fn });
    element.addEventListener(event, fn);
  };
  Listeners.prototype.removeAll = function () {
    this.entries = this.entries.filter(function (listener) {
      listener.element.removeEventListener(listener.event, listener.fn);
      return false;
    });
  };

  // node_modules/@shopify/theme-product/theme-product.js
  function getVariantFromSerializedArray(product, collection) {
    _validateProductStructure(product);
    var optionArray = _createOptionArrayFromOptionCollection(
      product,
      collection
    );
    return getVariantFromOptionArray(product, optionArray);
  }
  function getVariantFromOptionArray(product, options2) {
    _validateProductStructure(product);
    _validateOptionsArray(options2);
    var result = product.variants.filter(function (variant) {
      return options2.every(function (option, index) {
        return variant.options[index] === option;
      });
    });
    return result[0] || null;
  }
  function _createOptionArrayFromOptionCollection(product, collection) {
    _validateProductStructure(product);
    _validateSerializedArray(collection);
    var optionArray = [];
    collection.forEach(function (option) {
      for (var i = 0; i < product.options.length; i++) {
        if (
          product.options[i].name.toLowerCase() === option.name.toLowerCase()
        ) {
          optionArray[i] = option.value;
          break;
        }
      }
    });
    return optionArray;
  }
  function _validateProductStructure(product) {
    if (typeof product !== "object") {
      throw new TypeError(product + " is not an object.");
    }
    if (Object.keys(product).length === 0 && product.constructor === Object) {
      throw new Error(product + " is empty.");
    }
  }
  function _validateSerializedArray(collection) {
    if (!Array.isArray(collection)) {
      throw new TypeError(collection + " is not an array.");
    }
    if (collection.length === 0) {
      return [];
    }
    if (collection[0].hasOwnProperty("name")) {
      if (typeof collection[0].name !== "string") {
        throw new TypeError(
          "Invalid value type passed for name of option " +
            collection[0].name +
            ". Value should be string."
        );
      }
    } else {
      throw new Error(collection[0] + "does not contain name key.");
    }
  }
  function _validateOptionsArray(options2) {
    if (Array.isArray(options2) && typeof options2[0] === "object") {
      throw new Error(options2 + "is not a valid array of options.");
    }
  }

  // node_modules/@shopify/theme-product-form/theme-product-form.js
  var selectors = {
    idInput: '[name="id"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]',
  };
  function ProductForm(element, product, options2) {
    this.element = element;
    this.product = _validateProductObject(product);
    options2 = options2 || {};
    this._listeners = new Listeners();
    this._listeners.add(
      this.element,
      "submit",
      this._onSubmit.bind(this, options2)
    );
    this.optionInputs = this._initInputs(
      selectors.optionInput,
      options2.onOptionChange
    );
    this.quantityInputs = this._initInputs(
      selectors.quantityInput,
      options2.onQuantityChange
    );
    this.propertyInputs = this._initInputs(
      selectors.propertyInput,
      options2.onPropertyChange
    );
  }
  ProductForm.prototype.destroy = function () {
    this._listeners.removeAll();
  };
  ProductForm.prototype.options = function () {
    return _serializeOptionValues(this.optionInputs, function (item) {
      var regex = /(?:^(options\[))(.*?)(?:\])/;
      item.name = regex.exec(item.name)[2];
      return item;
    });
  };
  ProductForm.prototype.variant = function () {
    return getVariantFromSerializedArray(this.product, this.options());
  };
  ProductForm.prototype.properties = function () {
    var properties2 = _serializePropertyValues(
      this.propertyInputs,
      function (propertyName) {
        var regex = /(?:^(properties\[))(.*?)(?:\])/;
        var name = regex.exec(propertyName)[2];
        return name;
      }
    );
    return Object.entries(properties2).length === 0 ? null : properties2;
  };
  ProductForm.prototype.quantity = function () {
    return this.quantityInputs[0]
      ? Number.parseInt(this.quantityInputs[0].value, 10)
      : 1;
  };
  ProductForm.prototype._setIdInputValue = function (value) {
    var idInputElement = this.element.querySelector(selectors.idInput);
    if (!idInputElement) {
      idInputElement = document.createElement("input");
      idInputElement.type = "hidden";
      idInputElement.name = "id";
      this.element.appendChild(idInputElement);
    }
    idInputElement.value = value.toString();
  };
  ProductForm.prototype._onSubmit = function (options2, event) {
    event.dataset = this._getProductFormEventData();
    if (event.dataset.variant) {
      this._setIdInputValue(event.dataset.variant.id);
    }
    if (options2.onFormSubmit) {
      options2.onFormSubmit(event);
    }
  };
  ProductForm.prototype._onFormEvent = function (cb) {
    if (typeof cb === "undefined") {
      return Function.prototype;
    }
    return function (event) {
      event.dataset = this._getProductFormEventData();
      cb(event);
    }.bind(this);
  };
  ProductForm.prototype._initInputs = function (selector, cb) {
    var elements = Array.prototype.slice.call(
      this.element.querySelectorAll(selector)
    );
    return elements.map(
      function (element) {
        this._listeners.add(element, "change", this._onFormEvent(cb));
        return element;
      }.bind(this)
    );
  };
  ProductForm.prototype._getProductFormEventData = function () {
    return {
      options: this.options(),
      variant: this.variant(),
      properties: this.properties(),
      quantity: this.quantity(),
    };
  };
  function _serializeOptionValues(inputs, transform) {
    return inputs.reduce(function (options2, input) {
      if (
        input.checked ||
        (input.type !== "radio" && input.type !== "checkbox")
      ) {
        options2.push(transform({ name: input.name, value: input.value }));
      }
      return options2;
    }, []);
  }
  function _serializePropertyValues(inputs, transform) {
    return inputs.reduce(function (properties2, input) {
      if (
        input.checked ||
        (input.type !== "radio" && input.type !== "checkbox")
      ) {
        properties2[transform(input.name)] = input.value;
      }
      return properties2;
    }, {});
  }
  function _validateProductObject(product) {
    if (typeof product !== "object") {
      throw new TypeError(product + " is not an object.");
    }
    if (typeof product.variants[0].options === "undefined") {
      throw new TypeError(
        "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
      );
    }
    return product;
  }

  // node_modules/@shopify/theme-currency/currency.js
  var moneyFormat = "${{amount}}";
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ",",
      decimal = "."
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  // node_modules/@shopify/theme-images/images.js
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }
    if (size === "master") {
      return removeProtocol(src);
    }
    const match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );
    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
      return removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
  }
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  // node_modules/@shopify/theme-cart/request.js
  function getDefaultRequestConfig() {
    return JSON.parse(
      JSON.stringify({
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json;",
        },
      })
    );
  }
  function fetchJSON(url, config) {
    return fetch(url, config).then(function (response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  function cart() {
    return fetchJSON("/cart.js", getDefaultRequestConfig());
  }
  function cartAddFromForm(formData) {
    var config = getDefaultRequestConfig();
    delete config.headers["Content-Type"];
    config.method = "POST";
    config.body = formData;
    return fetchJSON("/cart/add.js", config);
  }
  function cartChange(line, options2) {
    var config = getDefaultRequestConfig();
    options2 = options2 || {};
    config.method = "POST";
    config.body = JSON.stringify({
      line,
      quantity: options2.quantity,
      properties: options2.properties,
    });
    return fetchJSON("/cart/change.js", config);
  }
  function cartClear() {
    var config = getDefaultRequestConfig();
    config.method = "POST";
    return fetchJSON("/cart/clear.js", config);
  }
  function cartUpdate(body) {
    var config = getDefaultRequestConfig();
    config.method = "POST";
    config.body = JSON.stringify(body);
    return fetchJSON("/cart/update.js", config);
  }

  // node_modules/@shopify/theme-cart/validate.js
  function key(key2) {
    if (typeof key2 !== "string" || key2.split(":").length !== 2) {
      throw new TypeError(
        "Theme Cart: Provided key value is not a string with the format xxx:xxx"
      );
    }
  }
  function quantity(quantity2) {
    if (typeof quantity2 !== "number" || isNaN(quantity2)) {
      throw new TypeError(
        "Theme Cart: An object which specifies a quantity or properties value is required"
      );
    }
  }
  function id(id2) {
    if (typeof id2 !== "number" || isNaN(id2)) {
      throw new TypeError("Theme Cart: Variant ID must be a number");
    }
  }
  function properties(properties2) {
    if (typeof properties2 !== "object") {
      throw new TypeError("Theme Cart: Properties must be an object");
    }
  }
  function form(form2) {
    if (!(form2 instanceof HTMLFormElement)) {
      throw new TypeError(
        "Theme Cart: Form must be an instance of HTMLFormElement"
      );
    }
  }
  function options(options2) {
    if (typeof options2 !== "object") {
      throw new TypeError("Theme Cart: Options must be an object");
    }
    if (
      typeof options2.quantity === "undefined" &&
      typeof options2.properties === "undefined"
    ) {
      throw new Error(
        "Theme Cart: You muse define a value for quantity or properties"
      );
    }
    if (typeof options2.quantity !== "undefined") {
      quantity(options2.quantity);
    }
    if (typeof options2.properties !== "undefined") {
      properties(options2.properties);
    }
  }

  // node_modules/@shopify/theme-cart/theme-cart.js
  function getState() {
    return cart();
  }
  function getItemIndex(key2) {
    key(key2);
    return cart().then(function (state) {
      var index = -1;
      state.items.forEach(function (item, i) {
        index = item.key === key2 ? i + 1 : index;
      });
      if (index === -1) {
        return Promise.reject(
          new Error("Theme Cart: Unable to match line item with provided key")
        );
      }
      return index;
    });
  }
  function addItemFromForm(form2) {
    form(form2);
    var formData = new FormData(form2);
    id(parseInt(formData.get("id"), 10));
    return cartAddFromForm(formData);
  }
  function updateItem(key2, options2) {
    key(key2);
    options(options2);
    return getItemIndex(key2).then(function (line) {
      return cartChange(line, options2);
    });
  }
  function removeItem(key2) {
    key(key2);
    return getItemIndex(key2).then(function (line) {
      return cartChange(line, { quantity: 0 });
    });
  }
  function clearItems() {
    return cartClear();
  }
  function updateAttributes(attributes) {
    return cartUpdate({ attributes });
  }

  // app/scripts/common/_tool.js
  var import_zenscroll = __toModule(require_zenscroll());
  var _AC = {
    addEvent: function (parent, evt, selector, handler) {
      evt.split(" ").forEach((event) => {
        parent.addEventListener(
          event,
          function (event2) {
            if (event2.target.matches(selector + ", " + selector + " *")) {
              handler.apply(event2.target.closest(selector), arguments);
            }
          },
          false
        );
      });
    },
    forEach: function (parent, selector, handler) {
      let _selectors = parent.querySelectorAll(selector);
      if (!_selectors.length) {
        return;
      }
      _selectors.forEach(function (event) {
        handler.apply(_selectors, arguments);
      });
    },
    debounceTime: function (time, func) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var excuteFn = function () {
          func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(excuteFn, time);
      };
    },
    detectDeviceType: () => {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? "Mobile"
        : "Desktop";
    },
    escape: (text) => {
      return text.replace(/[<>\&\"\']/g, function (c) {
        return "&#" + c.charCodeAt(0) + ";";
      });
    },
    fadeIn: function (elem, ms = 400) {
      if (!elem) return;
      elem.style.opacity = 0;
      elem.style.filter = "alpha(opacity=0)";
      elem.style.display = "inline-block";
      elem.style.visibility = "visible";
      if (ms) {
        var opacity = 0;
        var timer = setInterval(function () {
          opacity += 50 / ms;
          if (opacity >= 1) {
            clearInterval(timer);
            opacity = 1;
          }
          elem.style.opacity = opacity;
          elem.style.filter = "alpha(opacity=" + opacity * 100 + ")";
        }, 50);
      } else {
        elem.style.opacity = 1;
        elem.style.filter = "alpha(opacity=1)";
      }
    },
    fadeOut: function (elem, ms = 400) {
      if (!elem) return;
      if (ms) {
        var opacity = 1;
        var timer = setInterval(function () {
          opacity -= 50 / ms;
          if (opacity <= 0) {
            clearInterval(timer);
            opacity = 0;
            elem.style.display = "none";
            elem.style.visibility = "hidden";
          }
          elem.style.opacity = opacity;
          elem.style.filter = "alpha(opacity=" + opacity * 100 + ")";
        }, 50);
      } else {
        elem.style.opacity = 0;
        elem.style.filter = "alpha(opacity=0)";
        elem.style.display = "none";
        elem.style.visibility = "hidden";
      }
    },
    getCookie: (name) => {
      let dc = document.cookie,
        prefix = name + "=",
        begin = dc.indexOf("; " + prefix),
        end;
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
      } else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);
        if (end == -1) {
          end = dc.length;
        }
      }
      return decodeURI(dc.substring(begin + prefix.length, end));
    },
    getWidthBrowser: function () {
      let myWidth;
      if (typeof window.innerWidth == "number") {
        myWidth = window.innerWidth;
      } else if (
        document.documentElement &&
        (document.documentElement.clientWidth ||
          document.documentElement.clientHeight)
      ) {
        myWidth = document.documentElement.clientWidth;
      } else if (
        document.body &&
        (document.body.clientWidth || document.body.clientHeight)
      ) {
        myWidth = document.body.clientWidth;
      }
      return myWidth;
    },
    getHeightBrowser: function () {
      let result;
      if (typeof window.innerHeight == "number") {
        result = window.innerHeight;
      } else if (
        document.documentElement &&
        (document.documentElement.clientWidth ||
          document.documentElement.clientHeight)
      ) {
        result = document.documentElement.clientHeight;
      } else if (
        document.body &&
        (document.body.clientWidth || document.body.clientHeight)
      ) {
        result = document.body.clientHeight;
      }
      return result;
    },
    handle: (text) => {
      return text
        .toLowerCase()
        .replace(/[^\w\s.\//]/gi, "")
        .trim()
        .replace(/[\s.\//]/g, "-");
    },
    isExist: (element) => {
      return element == null || typeof element == "undefined" ? false : true;
    },
    scrollBarWidth: function () {
      let { left, right } = document.body.getBoundingClientRect();
      if (left + right < window.innerWidth)
        return window.innerWidth - (left + right);
      return 0;
    },
    scrollTo: function (selector) {
      let self2 = this;
      let el =
        typeof selector == "string"
          ? document.querySelector(selector)
          : selector;
      if (el == null) {
        return;
      }
      let elTop = el.getBoundingClientRect().top;
      let winTop =
        window.pageYOffset != void 0 ? window.pageYOffset : window.scrollTop;
      import_zenscroll.default.center(el, 1e3);
    },
    removeSquareBracket: (text) => {
      return text.replace(/\[|\]/g, "");
    },
    activeLazyload: (selector, fn) => {
      return new Promise((resolve, reject) => {
        selector.addEventListener("lazyincludeloaded", (e) => {
          fn(e);
          resolve(true);
        });
      });
    },
  };
  var tool_default = _AC;

  // app/scripts/common/_currency.js
  var AT_Currency = {
    currenciesCallback: function () {
      if (theme.currency.type != "2") {
        return;
      }
      var shopCurrency = "",
        defaultCurrency = "",
        cookieCurrency = "";
      let self2 = this;
      theme.currency.currenciesCallback = () => {
        if (Currency == null || theme.currency == null) {
          return;
        }
        Currency.format = theme.currency.currency_format;
        shopCurrency = theme.currency.shopCurrency;
        let formCurrency = document.querySelector('select[name="currency"]');
        if (formCurrency.value != shopCurrency) {
          formCurrency.value = shopCurrency;
          formCurrency.dispatchEvent(new Event("change"));
          formCurrency.closest("form").submit();
        }
        Currency.money_with_currency_format[shopCurrency] =
          theme.currency.moneyFormatWithCurrency_strip;
        Currency.money_format[shopCurrency] = theme.currency.moneyFormat_strip;
        defaultCurrency = shopCurrency;
        cookieCurrency = Currency.cookie.read();
        let spanMoney = document.querySelectorAll("span.money");
        spanMoney.length &&
          spanMoney.forEach((s) => {
            s.setAttribute(`data-currency-${shopCurrency}`, s.innerHTML);
          });
        if (cookieCurrency == null) {
          if (shopCurrency !== defaultCurrency) {
            Currency.convertAll(shopCurrency, defaultCurrency);
          } else {
            Currency.currentCurrency = defaultCurrency;
          }
          Currency.cookie.write(defaultCurrency);
        } else if (cookieCurrency === shopCurrency) {
          Currency.currentCurrency = shopCurrency;
        } else {
          typeof cookieCurrency == "undefined" &&
            (cookieCurrency = defaultCurrency);
          Currency.convertAll(shopCurrency, cookieCurrency);
          Currency.convertAll(Currency.currentCurrency, cookieCurrency);
        }
        self2.updateState();
      };
      theme.currency.currenciesCallbackSpecial = (id2) => {
        if (
          typeof Currency == "undefined" ||
          typeof theme.currency == "undefined"
        ) {
          return;
        }
        let target = document.querySelectorAll(id2);
        target.length &&
          target.forEach((element) => {
            element.setAttribute(
              `data-currency-${shopCurrency}`,
              element.innerHTML
            );
          });
        Currency.convertAll(
          shopCurrency,
          Currency.cookie.read(),
          id2,
          theme.currency.currency_format
        );
      };
    },
    convert: function (id2) {
      if (
        theme.currency.type != "2" ||
        !theme.currency ||
        !theme.currency.currenciesCallbackSpecial
      ) {
        return;
      }
      theme.currency.currenciesCallbackSpecial(id2);
    },
    updateState: function () {
      if (theme.currency.type != "2") {
        return;
      }
      let currentCurrency = tool_default.getCookie("currency");
      let labelCurrency = document.querySelectorAll("[data-currency-code]");
      let btnCurrency = document.querySelectorAll(".btn-currency[data-value]");
      currentCurrency.includes(";") &&
        (currentCurrency = currentCurrency.split(";")[0]);
      labelCurrency.length &&
        labelCurrency.forEach((c) => {
          c.textContent = currentCurrency;
        });
      btnCurrency.length &&
        btnCurrency.forEach((b) => {
          b.getAttribute("data-value") == currentCurrency
            ? b.classList.add("active")
            : b.classList.remove("active");
        });
    },
    initEvents: function () {
      let self2 = this;
      tool_default.addEvent(document, "click", ".btn-currency", (e) => {
        e.preventDefault();
        let _this = e.target,
          value = _this.getAttribute("data-value");
        switch (theme.currency.type) {
          case "1":
            let formCurrency = document.querySelector(
              "form.shopify-currency-form"
            );
            if (formCurrency == null) {
              return;
            }
            let optionSelect = formCurrency.querySelector("select");
            optionSelect.value = value;
            optionSelect.dispatchEvent(new Event("change"));
            formCurrency.submit();
            break;
          case "2":
            typeof Currency != "undefined" &&
              Currency.convertAll(Currency.currentCurrency, value);
            self2.updateState();
            break;
          default:
        }
      });
      theme.currency.type == "2" && theme.currency.currenciesCallback();
    },
    init: function () {
      if (!theme.currency.enable) {
        return;
      }
      let self2 = this;
      self2.currenciesCallback();
      self2.initEvents();
    },
  };
  var currency_default = AT_Currency;

  // app/scripts/common/_arn.js
  var oldWidth = 0;
  var dialog = {
    notify: "#dialogNotify",
  };
  var AT_Main = {
    onClick: function (className, callBack, container = document) {
      let target = container.querySelectorAll(className);
      target.length &&
        target.forEach(function (el, index) {
          el.addEventListener("click", callBack);
        });
    },
    isExist: (element) => {
      return element == null || typeof element == "undefined" ? false : true;
    },
    initDialog: () => {
      tool_default.addEvent(
        document,
        "click",
        "[data-dialog-trigger]",
        async (e) => {
          e.preventDefault();
          let _this = e.target,
            value = _this.getAttribute("data-dialog-trigger"),
            downVal = value.toLowerCase(),
            _target = document.querySelector(value);
          if (!tool_default.isExist(_target)) {
            return;
          }
          document.body.classList.add("lazy-loading");
          if (
            tool_default.isExist(
              _target.querySelector(":scope > .lazyload[data-include]")
            )
          ) {
            _target.classList.add("lazy-active");
            await tool_default.activeLazyload(_target, (e2) => {
              _target.classList.remove("lazy-active");
            });
          }
          AT_Main.disablePageScroll(true);
          document.body.classList.remove("lazy-loading");
          _target.classList.toggle("is-open");
          downVal.includes("menumobile") &&
            document.body.classList.toggle("menuMobile-is-active");
          if (!_target.classList.contains("is-open")) {
            return;
          }
          currency_default.convert(value + " .money");
          (downVal.includes("currency") || downVal.includes("menumobile")) &&
            currency_default.updateState();
          value.toLowerCase().includes("search") &&
            _target.querySelector('input[name="q"]').focus();
        }
      );
      tool_default.addEvent(document, "click", "[data-dialog-close]", (e) => {
        let _this = e.target,
          _target = _this.closest("dialog");
        if (!tool_default.isExist(_target)) {
          return;
        }
        e.preventDefault();
        _target.classList.remove("is-open");
        _target.getAttribute("id") == "menuMobile" &&
          document.body.classList.remove("menuMobile-is-active");
        AT_Main.disablePageScroll(false);
      });
    },
    triggerDialog(target, method = "show") {
      let _target = document.getElementById(target.replace(/^\W/g, ""));
      if (_target == null) {
        return;
      }
      if (method == "show") {
        document.querySelectorAll("dialog.is-open").length &&
          document.querySelectorAll("dialog.is-open").forEach((element) => {
            element.classList.remove("is-open");
          });
        document.body.classList.contains("menuMobile-is-active") &&
          document.body.classList.remove("menuMobile-is-active");
        _target.classList.add("is-open");
        AT_Main.disablePageScroll(true);
        return;
      }
      _target.classList.remove("is-open");
      AT_Main.disablePageScroll(false);
    },
    tabPanel_init: (container = null) => {
      let $container = container || document;
      let tabLink = $container.querySelectorAll(
        ".featured_group_tab-ui .featured_group_tab-link a"
      );
      tabLink.length &&
        tabLink.forEach((e) => {
          e.addEventListener("click", (e2) => {
            e2.preventDefault();
            let _this = e2.currentTarget,
              _target = $container.querySelector(_this.getAttribute("href"));
            if (
              _this
                .closest(".featured_group_tab-link")
                .classList.contains("active") ||
              !tool_default.isExist(_target)
            ) {
              return;
            }
            let paneParent = _target.closest(".featured_group_tab-ui");
            paneParent
              .querySelectorAll(
                ".featured_group_tab-pane.active, .featured_group_tab-link.active"
              )
              .forEach((e3, i) => {
                e3.classList.remove("active");
              });
            _this.closest(".featured_group_tab-link").classList.add("active");
            _target.classList.add("active");
          });
        });
    },
    initSlider: function (container) {
      let this2 = this;
      let ss = container,
        conf = ss.querySelector(`input[name="sectionSlideConfig"]`),
        target = ss.querySelectorAll(".slide_ui-element");
      if (
        !tool_default.isExist(target) ||
        !tool_default.isExist(conf) ||
        theme.slider == null
      ) {
        return;
      }
      let autoplay = false,
        autoplayTimeout = 5e3,
        center = false,
        animateIn = "tns-fadeIn",
        animateOut = "tns-fadeOut",
        speed = 300,
        edgePadding = 0,
        controls = conf.getAttribute("data-nav")
          ? JSON.parse(conf.getAttribute("data-nav"))
          : false,
        nav = conf.getAttribute("data-dot")
          ? JSON.parse(conf.getAttribute("data-dot"))
          : false,
        loop = conf.getAttribute("data-loop")
          ? JSON.parse(conf.getAttribute("data-loop"))
          : false,
        autoWidth = conf.getAttribute("data-auto-width")
          ? JSON.parse(conf.getAttribute("data-auto-width"))
          : false,
        items = conf.getAttribute("data-items").split(","),
        gutters = conf.getAttribute("data-gutters") || "",
        itemClass = conf.getAttribute("data-item-class");
      gutters = gutters.replace(/[^\d.,]/g, "").split(",");
      let sectionType = ss.getAttribute("data-section-type") || "";
      target.forEach((v, i) => {
        let wrapper = v.closest("div[data-slide-wrapper]") || ss;
        v.classList.remove("row", "d-grid");
        let responsive = {
          0: {
            items: +items[5] || +items[0],
            gutter: +gutters[5] || +gutters[0],
            center,
          },
          375: {
            items: +items[4] || +items[0],
            gutter: +gutters[4] || +gutters[0],
            center,
          },
          576: {
            items: +items[3] || +items[0],
            gutter: +gutters[3] || +gutters[0],
            center,
          },
          768: {
            items: +items[2] || +items[0],
            gutter: +gutters[2] || +gutters[0],
            center: false,
          },
          992: {
            items: +items[1] || +items[0],
            gutter: +gutters[1] || +gutters[0],
            center: false,
          },
          1200: {
            items: +items[0] || +items[0],
            gutter: +gutters[0] || +gutters[0],
            center: false,
          },
        };
        if (itemClass != "") {
          for (var i = 0; i < v.children.length; i++) {
            v.children[i].className = itemClass;
          }
        }
        let config = {
          container: v,
          items: items[5],
          gutter: gutters[5],
          slideBy: "page",
          startIndex: 0,
          loop,
          speed,
          edgePadding,
          mouseDrag: true,
          swipeAngle: 30,
          autoplayButtonOutput: false,
          autoplay,
          autoplayTimeout,
          animateIn,
          animateOut,
          controls,
          controlsPosition: "bottom",
          controlsContainer: wrapper.querySelector(".slide_ui-controls--nav"),
          nav,
          navPosition: "bottom",
          responsive,
          preventActionWhenRunning: false,
          preventScrollOnTouch: false,
          textDirection: document.body.dir,
          onInit: () => {
            if (tool_default.isExist(ss.querySelector(".tns-nav"))) {
              ss.querySelector(".tns-nav").classList.add(
                "slide_ui-controls",
                "slide_ui-controls--dot"
              );
            }
            if (sectionType.includes("product")) {
              v.querySelector(".tns-slide-active").classList.add("tns-first");
              v.querySelectorAll(".tns-slide-active")[
                v.querySelectorAll(".tns-slide-active").length - 1
              ].classList.add("tns-last");
            }
            ss.closest(".layout-full-right") != null &&
              this2.handleTestimonial(ss, "resize");
          },
        };
        let sliderTNS = theme.slider(config);
        if (sectionType.includes("product")) {
          sliderTNS.events.on("indexChanged", (info, eventName) => {
            v.querySelectorAll(".tns-first, .tns-last").forEach((item) => {
              item.classList.remove("tns-first", "tns-last");
            });
            v.querySelector(".tns-slide-active").classList.add("tns-first");
            v.querySelectorAll(".tns-slide-active")[
              v.querySelectorAll(".tns-slide-active").length - 1
            ].classList.add("tns-last");
          });
        }
      });
    },
    handleTestimonial: function (container, event = null) {
      let this2 = this;
      let calcEl = container.querySelector(".calc-container");
      let slideEl = container.querySelector(".tns-slider");
      let slideOuter = container.querySelector(".tns-outer");
      let translatedLeft = (container.clientWidth - calcEl.clientWidth) / 2;
      slideOuter.style.cssText = `padding-left: ${translatedLeft}px !important`;
      if (event == null) {
        return;
      }
      window.addEventListener("resize", function (e) {
        this2.handleTestimonial(container);
      });
    },
    escape: (text) => {
      return text.replace(/[<>\&\"\']/g, function (c) {
        return "&#" + c.charCodeAt(0) + ";";
      });
    },
    handle: (text) => {
      return text
        .toLowerCase()
        .replace(/[^\w\s.\//]/gi, "")
        .trim()
        .replace(/[\s.\//]/g, "-");
    },
    removeSquareBracket: (text) => {
      return text.replace(/\[|\]/g, "");
    },
    setCookie: (cname, cvalue, exdays) => {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1e3);
      let expires = "expires=" + d.toUTCString();
      document.cookie = `${cname}=${cvalue}; ${expires}; path=/`;
    },
    getCookie: (name) => {
      let dc = document.cookie,
        prefix = name + "=",
        begin = dc.indexOf("; " + prefix),
        end;
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
      } else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);
        if (end == -1) {
          end = dc.length;
        }
      }
      return decodeURI(dc.substring(begin + prefix.length, end));
    },
    clickModal: function (target) {
      tool_default.addEvent(document, "click", target, async (e) => {
        e.preventDefault();
        let _id = e.target.getAttribute("data-target") || "";
        let target2 = document.querySelector(_id);
        if (_id == "" || !tool_default.isExist(target2)) {
          return;
        }
        if (target2.classList.contains("active")) {
          target2.classList.remove("active");
          AT_Main.disablePageScroll(false);
        } else {
          target2.classList.add("active");
          AT_Main.disablePageScroll(true);
        }
      });
    },
    disablePageScroll: function (_bool, _class = null) {
      let bodyClass = [];
      bodyClass.push("modal-opened");
      _class != null && bodyClass.push(_class);
      let pr = tool_default.scrollBarWidth();
      if (_bool) {
        document.body.style.setProperty("padding-right", pr + "px");
        document.body.classList.add(...bodyClass);
        return;
      }
      document.body.style.removeProperty("padding-right");
      document.body.classList.remove(...bodyClass);
      return;
    },
    ajaxCall: (url, callback, method, postData, dataType) => {
      if (!window.XMLHttpRequest) {
        return null;
      }
      var req = new XMLHttpRequest();
      method = method || "GET";
      postData = postData || null;
      dataType = dataType || "text/plain";
      req.open(method, url);
      req.setRequestHeader("Content-Type", dataType);
      req.onreadystatechange = function () {
        if (req.readyState === 4) {
          if (req.status === 200) {
            callback(req.responseText);
          } else {
            console.log(req);
          }
        }
      };
      req.send(postData);
      return req;
    },
    recordRecentView: function (handle) {
      let recentView = AT_Main.getCookie("recentViewItem");
      recentView != null && (handle += `|${recentView}`);
      recentView = [...new Set(handle.split("|"))].join("|");
      AT_Main.setCookie("recentViewItem", recentView);
    },
    recentView: async function () {
      let self2 = this;
      let max = +theme.product.recent_total,
        recentView = AT_Main.getCookie("recentViewItem"),
        recentContainer = document.querySelector("#recentlyView"),
        lastestView = theme.productSettings ? theme.productSettings.handle : "";
      if (recentView == null || !tool_default.isExist(recentContainer)) {
        return;
      }
      let productHandle = [...new Set(recentView.split("|"))];
      productHandle.length > max &&
        (productHandle = productHandle.slice(0, max + 1));
      AT_Main.setCookie("recentViewItem", productHandle.join("|"));
      let lastestViewArray = productHandle.map(async (i) => {
        let url = `${theme.routes.search_url.replace(
          "search",
          ""
        )}products/${i}.js`;
        let resp = await fetch(url);
        let item = resp.ok ? resp.json() : "";
        return item;
      });
      let rencentRS = await Promise.all(lastestViewArray);
      (rencentRS.length > 1 ||
        (rencentRS.length == 1 &&
          rencentRS.some((i) => i.handle != lastestView))) &&
        (recentContainer.style.display = "block");
      if (recentContainer.style.display != "block") {
        return;
      }
      let itemArray = [];
      rencentRS.forEach(async (value, index) => {
        if (value.handle && value.handle != lastestView) {
          await itemArray.push(
            self2.renderItem(value, "[data-recent-container]")
          );
        }
      });
      let itemArrayResult = await Promise.all(itemArray);
      AT_Main.initSlider(recentContainer);
      currency_default.convert("#recentlyView .money");
    },
    renderItem: async (item, target) => {
      let settings = {
          productCard: "#productCardLayout",
          itemKey: "[data-item-key]",
          itemImage: "[data-item-image]",
          itemURL: "[data-item-url]",
          itemTitle: "[data-item-title]",
          itemOption: "[data-item-option]",
          itemPrice: "[data-item-price]",
          itemComparePrice: "[data-item-price-compare]",
        },
        wrapper = document.querySelector(target),
        selector =
          document.querySelector(settings.productCard) ||
          AT_Main.renderSelector;
      if (wrapper == null) {
        return;
      }
      if (selector == null) {
        let itemHTML = new Promise((re, rs) => {
          fetch(theme.routes.search_url + "?view=include.product-item").then(
            (e) => {
              e.text().then((resp) => {
                re(resp);
              });
            }
          );
        });
        let result = await itemHTML;
        let parser = new DOMParser();
        let html = parser.parseFromString(result, "text/html");
        selector = html.querySelector(settings.productCard);
      }
      let productSelected = item.variants[0];
      selector.querySelectorAll(settings.itemURL).forEach((e) => {
        e.setAttribute("href", item.url);
      });
      selector.querySelector(settings.itemTitle).innerHTML = item.title;
      selector.querySelector(settings.itemPrice).innerHTML = formatMoney(
        item.price,
        theme.currency.moneyFormat
      );
      selector.querySelector(settings.itemComparePrice).innerHTML = formatMoney(
        item.compare_at_price,
        theme.currency.moneyFormat
      );
      let image = item.featured_image || theme.product.default_image;
      selector
        .querySelector(settings.itemImage)
        .setAttribute("data-src", getSizedImageUrl(image, "280x"));
      selector
        .querySelector(settings.itemImage)
        .setAttribute("alt", item.title);
      selector.querySelector(settings.itemImage).classList.add("lazyload");
      if (item.compare_at_price == null)
        selector.querySelector(settings.itemComparePrice).classList.add("hide");
      else
        selector
          .querySelector(settings.itemComparePrice)
          .classList.remove("hide");
      let _html = selector.innerHTML;
      target == "[data-recent-container]" &&
        (_html = `<div class="product-section">${_html}</div>`);
      wrapper.insertAdjacentHTML("beforeend", _html);
      return true;
    },
    getItems: async (arrayHandle, index = 0) => {
      if (index >= arrayHandle.length) {
        return;
      }
      let url = `${theme.routes.search_url.replace("search", "")}products/${
        arrayHandle[index]
      }.js`;
      let response = await fetch(url);
      return await response.json();
    },
    moneyFormat: (price) => {
      return formatMoney(price, theme.currency.moneyFormat);
    },
    changePrice: (variant, target, settings) => {
      let price = target.querySelector(settings.price) || {},
        priceSale = target.querySelector(settings.price_sale) || {},
        priceCompare = target.querySelector(settings.price_compare) || {},
        soldout = target.querySelector(settings.soldout) || {};
      price.classList.add("hide");
      priceSale.classList.add("hide");
      priceCompare.classList.add("hide");
      soldout.classList.add("hide");
      if (variant === null || !variant.available) {
        soldout.classList.remove("hide");
        return;
      }
      if (variant.available) {
        soldout.classList.add("hide");
        if (
          variant.compare_at_price != null &&
          variant.compare_at_price > variant.price
        ) {
          priceSale.innerHTML = formatMoney(
            variant.price,
            theme.currency.moneyFormat
          );
          priceCompare.innerHTML = formatMoney(
            variant.compare_at_price,
            theme.currency.moneyFormat
          );
          priceSale.classList.remove("hide");
          priceCompare.classList.remove("hide");
        } else {
          price.innerHTML = formatMoney(
            variant.price,
            theme.currency.moneyFormat
          );
          price.classList.remove("hide");
        }
      }
    },
    easyTimer_HTML: function (selector, value) {
      if (value > 9) {
        let arrValue = value.toString().split("");
        arrValue.forEach((val, index) => {
          let target = selector.querySelector(
            `.date-value[data-index="${index + 1}"]`
          );
          if (!tool_default.isExist(target)) {
            let prevElment = selector.querySelector(
              `.date-value[data-index="${index}"]`
            );
            let renderHTML = prevElment.outerHTML
              .replace(`data-index="${index}"`, `data-index="${index + 1}"`)
              .replace(
                `${prevElment.innerHTML}</span>`,
                `${arrValue[index]}</span`
              );
            selector
              .querySelector(`.date-value[data-index="${index}"]`)
              .insertAdjacentHTML("afterend", renderHTML);
            return;
          }
          target.innerHTML = arrValue[index];
        });
      } else {
        selector.querySelector('.date-value[data-index="1"]').innerHTML = 0;
        selector.querySelector('.date-value[data-index="2"]').innerHTML = value;
      }
    },
    initSwatch: (container = document) => {
      let swtArray = container.querySelectorAll(
        '[data-swatch-wrapper] input[type="radio"]'
      );
      if (!swtArray.length) {
        return;
      }
      swtArray.forEach((swt) => {
        swt.addEventListener("change", (e) => {
          let value = swt.value,
            optionSelect = document.querySelector(
              swt.closest(".swatch-option").getAttribute("data-target")
            );
          optionSelect.value = value;
          optionSelect.dispatchEvent(new Event("change"));
        });
      });
    },
    init_EasyTimer: function (selector, time_second) {
      let timer = new import_easytimer.Timer();
      timer.start({ countdown: true, startValues: { seconds: time_second } });
      timer.addEventListener("secondsUpdated", function (e) {
        let d = timer.getTimeValues().days,
          h = timer.getTimeValues().hours,
          m = timer.getTimeValues().minutes,
          s = timer.getTimeValues().seconds;
        let totalHours = d * 24 + h;
        totalHours > 99
          ? AT_Main.easyTimer_HTML(selector.querySelector(".count-day"), d)
          : selector.querySelector(".count-day").classList.add("hide");
        AT_Main.easyTimer_HTML(
          selector.querySelector(".count-hrs"),
          totalHours > 99 ? h : totalHours
        );
        AT_Main.easyTimer_HTML(selector.querySelector(".count-min"), m);
        AT_Main.easyTimer_HTML(selector.querySelector(".count-sec"), s);
        if (!JSON.parse(selector.getAttribute("data-hide-label"))) {
          let d_t = d > 1 ? theme.dateLabel.days : theme.dateLabel.day,
            h_t = h > 1 ? theme.dateLabel.hours : theme.dateLabel.hour,
            m_t = m > 1 ? theme.dateLabel.minutes : theme.dateLabel.minute,
            s_t = s > 1 ? theme.dateLabel.seconds : theme.dateLabel.second;
          selector.querySelector(".count-day .date-label").innerHTML = d_t;
          selector.querySelector(".count-hrs .date-label").innerHTML = h_t;
          selector.querySelector(".count-min .date-label").innerHTML = m_t;
          selector.querySelector(".count-sec .date-label").innerHTML = s_t;
        }
        selector.classList.add("countdown-loaded");
      });
      timer.addEventListener("targetAchieved", function (e) {
        selector.classList.add("hide");
      });
    },
    initCountdown: function (target = null) {
      let container = target;
      if (container == null) {
        container = document;
      }
      let countdownItems = container.querySelectorAll(
        ".countdown-time:not(.countdown-loaded)"
      );
      if (!countdownItems.length) {
        return;
      }
      countdownItems.forEach((e) => {
        if (!e.classList.contains("countdown-loaded")) {
          let _this = e,
            _value = _this.getAttribute("data-date").split("/"),
            _date =
              new Date(_value[2], Number(_value[0]) - 1, _value[1]).getTime() /
              1e3,
            _now = new Date().getTime() / 1e3,
            countdownTime = _date > _now ? _date - _now : 0;
          if (countdownTime > 0) AT_Main.init_EasyTimer(_this, countdownTime);
          else _this.remove();
        }
      });
    },
    initCountryProvinceSelector: () => {
      let target = document.querySelectorAll(
        ".customer_address_table[data-id]"
      );
      if (!target.length) {
        return;
      }
      new Shopify.CountryProvinceSelector(
        "address_country_new",
        "address_province_new",
        { hideElement: "address_province_container_new" }
      );
      target.forEach((element) => {
        let formId = element.getAttribute("data-id");
        let countrySelector = "address_country_" + formId;
        let provinceSelector = "address_province_" + formId;
        let containerSelector = "address_province_container_" + formId;
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector,
        });
      });
    },
    initVideo: function (container) {
      let buttonVideo = container.querySelectorAll("[data-button-video]");
      buttonVideo.length &&
        buttonVideo.forEach((btn) => {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            let parent = e.currentTarget.closest("[data-video-container]"),
              videoElement = parent.querySelector("video");
            if (parent.classList.contains("video-playing")) {
              parent.classList.remove("video-playing");
              tool_default.isExist(videoElement) && videoElement.pause();
            } else {
              parent.classList.add("video-playing");
              tool_default.isExist(videoElement) && videoElement.play();
            }
          });
        });
    },
    scrollToTop: function () {
      let bodyTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (bodyTop > 0) {
        window.requestAnimationFrame(AT_Main.scrollToTop);
        window.scrollTo(0, bodyTop - bodyTop / 8);
      }
    },
    resetCollectionPagination: () => {
      if (theme.collectionPagination == null) {
        return;
      }
      updateAttributes({ pagination: null });
    },
    fixReview: function () {
      let reviewLazy = document.querySelectorAll(
        ".featured_product__item-review:not(.loaded)"
      );
      reviewLazy.length &&
        reviewLazy.forEach((e) => {
          e.addEventListener("lazyincludeloaded", (evt) => {
            if (
              theme.product.review_type == "shopify" &&
              typeof SPR != "undefined"
            ) {
              SPR.initDomEls();
              window.loadBadges.call(SPR);
            }
          });
        });
    },
    showNotify: async function (text) {
      let content = document.querySelector(dialog.notify);
      if (content == null) {
        let getDialog = await fetch(
          `${theme.routes.search_url}?view=dialog.notification`
        );
        let dialogEl = await getDialog.text();
        document.body.insertAdjacentHTML("beforeend", dialogEl);
        content = document.querySelector(dialog.notify);
      }
      content = content.querySelector("[data-notify-content]");
      content.innerHTML = text || theme.cart.error_add_cart;
      AT_Main.triggerDialog(dialog.notify);
    },
    subscribeForm: function () {
      let self2 = this;
      self2.subscribeFail = () => {
        AT_Main.showNotify(
          `Could not connect to the registration server. Please try again later.`
        );
      };
      self2.ajaxMailchimp = (form3) => {
        let url = form3.getAttribute("action"),
          email = form3.querySelector('input[type="email"]'),
          ud = `&EMAIL=${encodeURIComponent(email.value)}`;
        if (url == "") {
          self2.subscribeFail();
          return;
        }
        let script = document.createElement("script");
        script.src = url + ud;
        document.body.appendChild(script);
        let callback = "mailchimpCallback";
        window[callback] = function (data) {
          delete window[callback];
          document.body.removeChild(script);
          if (data.result == "success") {
            email.value = "";
            AT_Main.showNotify(
              form3.querySelector(".thank_you").innerText || data.msg
            );
          } else {
            self2.subscribeFail();
          }
        };
      };
      let form2 = [...document.querySelectorAll("form.form-subscribe")];
      form2.length &&
        form2.map((f) => {
          let type = f.getAttribute("data-form-type");
          f.addEventListener("submit", (e) => {
            let url = f.getAttribute("action");
            if (type == "mailchimp") {
              e.preventDefault();
              self2.ajaxMailchimp(f);
            }
            if (
              type == "klaviyo" &&
              (url == "" || typeof KlaviyoSubscribe == "undefined")
            ) {
              e.preventDefault();
              self2.subscribeFail();
              return;
            }
          });
          if (type == "klaviyo" && typeof KlaviyoSubscribe != "undefined") {
            KlaviyoSubscribe.attachToForms(f, {
              custom_success_message: true,
              success: function ($form) {
                let email = $form.find('input[type="email"]');
                email.val("");
                AT_Main.showNotify($form.find(".thank_you").text());
              },
            });
          }
        });
    },
    initEvents: function () {
      let this2 = this;
      this2.fixReview();
      this2.initDialog();
      this2.subscribeForm();
      this2.clickModal("a[data-target]");
      Shopify.moneyFormat = function (a, b) {
        return formatMoney(a, b);
      };
      document.body.addEventListener(
        "click",
        function (e) {
          let target = e.target;
          if (document.body.classList.contains("modal-opened")) {
            ((target.closest(".ssw-login") != null &&
              target.closest(".ssw-modal-content") == null) ||
              target.classList.contains("ssw-close")) &&
              document.body.classList.remove("modal-opened");
          }
        },
        true
      );
      tool_default.addEvent(
        document,
        "click",
        ".sb-btn-show",
        (e) => {
          e.preventDefault();
          let id2 = e.target.getAttribute("data-target");
          let target = document.querySelector(id2) || null;
          if (target == null) {
            return;
          }
          target.classList.add("active");
          AT_Main.disablePageScroll(true);
        },
        false
      );
      tool_default.addEvent(
        document,
        "click",
        ".sb-btn-close",
        (e) => {
          e.preventDefault();
          let id2 = e.target.getAttribute("data-target");
          let target = document.querySelector(id2) || null;
          if (target == null) {
            return;
          }
          target.classList.remove("active");
          AT_Main.disablePageScroll(false);
        },
        false
      );
      let backToTop = document.querySelector("#backToTop");
      if (tool_default.isExist(backToTop)) {
        backToTop.addEventListener("click", (e) => {
          e.preventDefault();
          AT_Main.scrollToTop();
        });
        window.addEventListener(
          "scroll",
          (e) => {
            let scrollTop = window.scrollY;
            if (
              scrollTop > 100 &&
              scrollTop + window.innerHeight < document.body.clientHeight - 100
            ) {
              backToTop.classList.add("active");
            } else {
              backToTop.classList.remove("active");
            }
          },
          { passive: false }
        );
      }
      if (Storage !== void 0) {
        if (document.body.classList.contains("templateCollection")) {
          sessionStorage.collection = theme.collectionLink;
        }
        if (
          document.querySelector("#continueShopping") != null &&
          typeof sessionStorage.collection != "undefined"
        ) {
          document.querySelector("#continueShopping").href =
            sessionStorage.collection;
        }
      }
      tool_default.addEvent(document, "click", ".btn-language", (e) => {
        e.preventDefault();
        let _this = e.target,
          lang = _this.getAttribute("data-lang"),
          returnTo = _this.closest("dialog").getAttribute("data-return"),
          url = location.origin + lang + returnTo;
        window.location.href = url;
      });
      window.addEventListener("scroll", (e) => {
        let sequenceLazy = document.querySelectorAll(".lazyqueue-wait");
        sequenceLazy.forEach((v, i) => {
          v.classList.add("lazyqueue-active");
        });
      });
      document.body.addEventListener("lazyincludeloaded", (e) => {
        if (e.target.closest(".lazyqueue-wait") != null) {
          e.target
            .closest(".lazyqueue-wait")
            .classList.remove("lazyqueue-active", "lazyqueue-wait");
        }
      });
      window.addEventListener("load", () => {
        this2.recentView();
        if (window.location.href.includes("shopifypreview")) {
          let target = document.querySelector("#preview-bar-iframe");
          tool_default.isExist(target) && (target.style.display = "none");
          tool_default.debounceTime(1e3, () => {
            document.body.closest("html").style.paddingBottom = null;
          })();
        }
        if (tool_default.getWidthBrowser() < 768) {
          let target = document.querySelector("#admin-bar-iframe");
          tool_default.isExist(target) && (target.style.display = "none");
          tool_default.debounceTime(1e3, () => {
            document.body.closest("html").style.paddingBottom = null;
          })();
        }
      });
      window.addEventListener("resize", () => {
        if (oldWidth == tool_default.getWidthBrowser()) {
          return;
        }
        oldWidth = tool_default.getWidthBrowser();
      });
      tool_default.addEvent(
        document,
        "click",
        "#announcement-bar--close",
        (e) => {
          e.preventDefault();
          let _parent = e.target.closest("[data-section-type]");
          tool_default.isExist(_parent) && tool_default.fadeOut(_parent);
        }
      );
    },
    init: function () {
      oldWidth = tool_default.getWidthBrowser();
      this.initEvents();
      this.initCountdown();
      this.initCountryProvinceSelector();
      this.resetCollectionPagination();
    },
  };
  var arn_default = AT_Main;

  // app/scripts/common/_cart.js
  var currencyConvert = currency_default.convert;
  var AT_Cart = {
    settings: {
      dialog: "cartNoti",
      cartDrawer: "cartShopping",
      cartCount: "[data-cart-count]",
      total: "[data-cart-total]",
      removeItem: "[data-item-remove]",
      removeAll: "[data-cart-remove-all]",
      waitingClass: "cart-waiting",
      cartBody: "[data-cart-body]",
      lineItem: "[data-line-item]",
      itemKey: "[data-item-key]",
      itemLinePrice: "[data-item-line-price]",
      itemQty: "[data-item-qty]",
      replaceContent: "[data-cart-replace]",
      cartAction: theme.cart.action || "cart",
      locale: theme.routes.root_url == "/" ? "" : theme.routes.root_url,
    },
    init: function () {
      this.initEvents();
    },
    initEvents: function () {
      let this2 = this,
        settings = this2.settings,
        isLazyActive = false,
        cartDialog = document.getElementById(settings.dialog);
      tool_default.addEvent(
        document,
        "click touchend",
        ".add-to-cart",
        async (e) => {
          let btn = e.target;
          if (btn.classList.contains("btn-require-options")) {
            e.preventDefault();
            alert(
              "Some required options have been left empty, unselected, or wrongly filled",
              "required-options"
            );
            tool_default.scrollTo(
              document.querySelector(".product-form-cart [data-product-form]")
            );
            return false;
          }
          if (!theme.cart.ajax || settings.cartAction == "cart") {
            return;
          }
          e.preventDefault();
          this2.buttonLoading(btn);
          if (btn.closest(settings.replaceContent) != null) {
            let key2 = btn.closest(settings.replaceContent).dataset.itemKey;
            try {
              await removeItem(key2);
            } catch (error2) {
              console.log(error2);
            }
          }
          this2.addCart(btn);
        }
      );
      tool_default.addEvent(
        document,
        "click",
        ".btn-link-cart:not(.soldout)",
        (e) => {
          e.preventDefault();
          let _this = e.target,
            container = _this.closest("[data-product-card]");
          this2.buttonLoading(_this);
          if (!tool_default.isExist(container)) {
            return;
          }
          let button = container.querySelector('form button[type="submit"]');
          tool_default.isExist(button) && button.click();
        }
      );
      tool_default.addEvent(
        document,
        "click",
        '[data-dialog-trigger="#cartShopping"]',
        async (e) => {
          await this2.getCartDrawer();
          arn_default.triggerDialog(this2.settings.cartDrawer);
        }
      );
      let qtyWrapper =
          "[data-quantity] a.qty-plus, [data-quantity] a.qty-minus",
        inputQty = "[data-quantity] input";
      theme.cart.ajax_change_qty &&
        tool_default.addEvent(
          document,
          "keyup",
          inputQty,
          tool_default.debounceTime(300, (e) => {
            e.preventDefault();
            let input = e.target,
              oldValue = +input.value || 1,
              currentValue = +input.value || 1,
              min = +input.getAttribute("min") || 0;
            if (input.hasAttribute("disabled")) {
              return;
            }
            currentValue < min && (input.value = min);
            if (
              input.hasAttribute(settings.itemKey.replace(/\[|\]/g, ""), "") &&
              currentValue >= min
            ) {
              this2.quantityChange(input);
            }
          })
        );
      tool_default.addEvent(
        document,
        "click",
        qtyWrapper,
        tool_default.debounceTime(0, (e) => {
          e.preventDefault();
          let _this = e.target,
            input = _this.closest("[data-quantity]").querySelector("input"),
            oldValue = +input.value,
            currentValue = +input.value,
            min = +input.getAttribute("min") || 0,
            max = +input.getAttribute("max") || null;
          if (input.hasAttribute("disabled")) {
            return;
          }
          if (_this.classList.contains("qty-plus")) {
            if (max != null && currentValue + 1 > max) {
              this2.currentLine = _this.closest(settings.lineItem);
              this2.showNotify();
              return;
            }
            currentValue += 1;
          } else {
            currentValue > min && (currentValue -= 1);
          }
          input.value = currentValue;
          if (
            theme.cart.ajax_change_qty &&
            input.hasAttribute(settings.itemKey.replace(/\[|\]/g, ""), "") &&
            currentValue >= min &&
            oldValue != currentValue
          ) {
            if (this2.waitQuantityUpdate !== null) {
              clearTimeout(this2.waitQuantityUpdate);
            }
            this2.waitQuantityUpdate = setTimeout(function () {
              this2.quantityChange(input);
              this2.waitQuantityUpdate = null;
            }, 500);
          }
        })
      );
      tool_default.addEvent(document, "click", settings.removeItem, (e) => {
        e.preventDefault();
        let _this = e.target,
          key2 = _this.getAttribute("data-item-key");
        _this.classList.add("running");
        tool_default.fadeOut(_this.closest(settings.lineItem));
        removeItem(key2)
          .then((state) => {
            _this.closest(settings.lineItem).remove();
            theme.template == "cart"
              ? this2.updateCart(state)
              : this2.updateCartState(state);
          })
          .catch((error2) => {
            console.log(error2);
          });
      });
      tool_default.addEvent(document, "click", ".clear-cart-items", (e) => {
        e.preventDefault();
        clearItems().then((state) => {
          this2.updateCart(state);
        });
      });
      let clearCartAttributes = (e) => {
        e.preventDefault();
        updateAttributes({ pagination: null, view_cata: null }).then(
          (state) => {
            window.location.href = theme.routes.cart_url.replace(
              "cart",
              "checkout"
            );
          }
        );
      };
      tool_default.addEvent(
        document,
        "click",
        ".btn-go-checkout",
        clearCartAttributes
      );
      tool_default.addEvent(
        document,
        "click",
        'button[name="checkout"]',
        clearCartAttributes
      );
      let bundleCart = document.querySelector("[data-bundle-submit]");
      tool_default.addEvent(document, "click", "[data-bundle-submit]", (e) => {
        e.preventDefault();
        let _this = e.target;
        this2.addBundleToCart(_this);
      });
      let cartNote = document.querySelector('textarea[name="note"]');
      if (cartNote != null) {
        cartNote.addEventListener("focus", function (e) {
          this.closest("div").classList.add("note-active");
        });
        cartNote.addEventListener("blur", function (e) {
          this.closest("div").classList.remove("note-active");
        });
      }
      let stickyBtn = document.getElementById("stickyAddCartBtn");
      stickyBtn != null &&
        stickyBtn.addEventListener("click", function (e) {
          if (
            !stickyBtn.hasAttribute("disabled") &&
            !stickyBtn.classList.contains("btn-require-options")
          ) {
            this2.buttonLoading(stickyBtn);
          }
          let btnContainer = document.querySelector("[item-cart]");
          let btnAddCart = btnContainer.querySelector('button[type="submit"]');
          btnAddCart.click();
        });
    },
    addCart: function (selector) {
      let this2 = this,
        settings = this.settings,
        form2 = selector.closest("[data-product-form]");
      if (form2 === null) {
        return;
      }

      addItemFromForm(form2).then(
        (item) => {
          if (settings.cartAction == "checkout") {
            window.location.href = theme.routes.cart_url.replace(
              "cart",
              "checkout"
            );
            return;
          }
          this2
            .getCartState()
            .then(async function (e) {
              if (settings.cartAction == "drawer") {
                await this2.getCartDrawer();
                Array.prototype.forEach.call(
                  document.querySelectorAll(".is-open"),
                  (i) => {
                    let modalOpening = i.querySelector("[data-dialog-close]");
                    modalOpening !== null && modalOpening.click();
                  }
                );
                let itemExist = document.querySelector(
                  `#${this2.settings.cartDrawer} [name="quantity"][data-item-key="${item.key}"]`
                );
                if (itemExist !== null) {
                  if (this2.cartDrawerEl.classList.contains("js-ajax-cart")) {
                    itemExist.setAttribute("value", item.quantity);
                  } else {
                    itemExist.innerHTML = item.quantity;
                    let label = itemExist
                      .closest(settings.lineItem)
                      .querySelector("[data-item-qty-label]");
                    label != null &&
                      (label.innerHTML =
                        item.quantity > 1 ? theme.cart.items : theme.cart.item);
                  }
                } else {
                  let respLayout = await fetch(
                    `${this2.settings.locale}/products/${item.handle}/${item.id}?view=include.cart-line-item`
                  );
                  respLayout = await respLayout.text();
                  let cartBody = document
                    .getElementById(this2.settings.cartDrawer)
                    .querySelector(settings.cartBody);
                  cartBody.insertAdjacentHTML("afterbegin", respLayout);
                  Array.prototype.forEach.call(
                    document.querySelectorAll(`.cart-item-block`),
                    (i, index) => {
                      i.classList = `${i.dataset.class} animation-fade-index-${index}`;
                    }
                  );
                  currencyConvert(`${settings.cartBody} .money`);
                }
                arn_default.triggerDialog(settings.cartDrawer);
              } else {
                let popupExist = document.getElementById(this2.settings.dialog);
                popupExist !== null && popupExist.remove();
                if (document.getElementById("cartDialogStyle") == null) {
                  let l = document.createElement("link");
                  l.type = "text/css";
                  l.id = "cartDialogStyle";
                  l.rel = "stylesheet";
                  l.media = "all";
                  l.href = theme.resource.cart_dialog.css;
                  document.body.appendChild(l);
                }
                fetch(
                  `${this2.settings.locale}/products/${item.handle}/${item.id}?view=include.dialog-cart`
                )
                  .then((resp) => resp.text())
                  .then((resp) => {
                    document.body.insertAdjacentHTML("beforeend", resp);
                    arn_default.initSlider(
                      document.getElementById(settings.dialog)
                    );
                    currencyConvert(`#${settings.dialog} .money`);
                    arn_default.triggerDialog(settings.dialog);
                  });
              }
              this2.updateCart(e);
            })
            .catch((error2) => {
              console.error("Error:", error2), this2.showNotify(error2);
            });
        },
        (error2) => {
          error2.json().then((error3) => {
            console.error("Error:", error3),
              this2.showNotify(error3.description);
            this2.updateCartState();
          });
        }
      );
    },
    addBundleToCart: function (selector) {
      let this2 = this;
      let settings = this.settings;
      let lineItems = selector
        .closest("[data-bundle-container]")
        .querySelectorAll('input[name="bundleGroup"]:checked');
      if (!lineItems.length) {
        return;
      }
      selector.classList.add(settings.waitingClass);
      let items = [];
      lineItems.forEach((item) => {
        items.push({ id: +item.dataset.id, quantity: 1 });
      });
      fetch(`${theme.routes.cart_add_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      })
        .then((resp) => {
          if (settings.cartAction == "cart") {
            window.location.href = theme.routes.cart_url;
            return;
          } else if (settings.cartAction == "checkout") {
            window.location.href = theme.routes.cart_url.replace(
              "cart",
              "checkout"
            );
            return;
          }
          resp
            .json()
            .then(async (resp2) => {
              if (settings.cartAction == "drawer") {
                if (resp2.status == 422) {
                  this2.showNotify(resp2.description);
                } else {
                  await this2.getCartDrawer();
                  let arrayItems = [];
                  resp2.items.length &&
                    resp2.items.forEach(async (item) => {
                      let itemExist = document.querySelector(
                        `#${this2.settings.cartDrawer} [name="quantity"][data-item-key="${item.key}"]`
                      );
                      if (itemExist !== null) {
                        itemExist.setAttribute("value", item.quantity);
                      } else {
                        arrayItems.push(
                          new Promise((resolve, reject) => {
                            fetch(
                              `${this2.settings.locale}/products/${item.handle}/${item.id}?view=include.cart-line-item`
                            )
                              .then((resp3) => resp3.text())
                              .then((respLayout) => {
                                resolve(respLayout);
                              });
                          })
                        );
                      }
                    });
                  if (arrayItems.length) {
                    let allItemsLayout = await Promise.all(arrayItems);
                    let cartBody = document
                      .getElementById(this2.settings.cartDrawer)
                      .querySelector(settings.cartBody);
                    cartBody.insertAdjacentHTML(
                      "afterbegin",
                      allItemsLayout.join("")
                    );
                    Array.prototype.forEach.call(
                      document.querySelectorAll(`.cart-item-block`),
                      (i, index) => {
                        i.classList = `${i.dataset.class} animation-fade-index-${index}`;
                      }
                    );
                  }
                  arn_default.triggerDialog(settings.cartDrawer);
                }
              } else {
                let msg =
                  resp2.status == 422
                    ? resp2.description
                    : theme.cart.success_add_cart;
                this2.showNotify(msg);
              }
              let state = await this2.getCartState();
              this2.updateCart(state);
            })
            .catch((error2) => {
              console.log(error2);
            });
        })
        .catch((err) => {
          console.error("Error:", error);
          this2.showNotify(error);
          selector.classList.remove(settings.waitingClass);
          this2.updateCartState();
        });
    },
    quantityChange: function (input) {
      let this2 = this;
      let key2 = input.getAttribute(
        this2.settings.itemKey.replace(/\[|\]/g, "")
      );
      let qty = +input.value;
      updateItem(key2, { quantity: qty }).then((cart2) => {
        let itemQty = cart2.items.find((i) => i.key == key2).quantity;
        if (itemQty == qty) {
          AT_Cart.updateCart(cart2);
        } else {
          input.setAttribute("value", itemQty);
          this2.currentLine = input.closest(this2.settings.lineItem);
          input.value = itemQty;
          this2.showNotify();
        }
      });
    },
    buttonLoading: function (button, bool = true) {
      let className = this.settings.waitingClass;
      bool
        ? button.classList.add(className)
        : button.classList.remove(className);
    },
    getCartState: function () {
      return new Promise((resolve, reject) => {
        getState()
          .then(async (cart2) => {
            resolve(cart2);
          })
          .catch((error2) => {
            reject(error2);
          });
      });
    },
    getCartDrawer: function () {
      let this2 = this;
      let el = document.getElementById(this2.settings.cartDrawer);
      return new Promise((resolve, reject) => {
        if (el !== null) {
          resolve(0);
          return;
        }
        if (document.getElementById("cartDrawerStyle") == null) {
          let l = document.createElement("link");
          l.type = "text/css";
          l.id = "cartDrawerStyle";
          l.rel = "stylesheet";
          l.media = "all";
          l.href = theme.resource.cart_drawer.css;
          document.body.appendChild(l);
        }
        fetch(`${theme.routes.search_url}?view=include.cart-drawer`)
          .then((resp) => resp.text())
          .then((resp) => {
            document.body.insertAdjacentHTML("beforeend", resp);
            currencyConvert(`#${this2.settings.cartDrawer} .money`);
            this2.cartDrawerEl = document.getElementById(
              this2.settings.cartDrawer
            );
            document.body.classList.remove("lazy-loading");
            resolve(0);
          })
          .catch((error2) => {
            reject(error2);
          });
      });
    },
    updateCart: async function (state) {
      let this2 = this;
      let settings = this.settings;
      if (theme.template == "cart") {
        if (state.item_count > 0) {
          state.items.forEach((item) => {
            let line = document.querySelector(`[data-item-key="${item.key}"]`);
            if (line != null) {
              let itemLinePrice = line
                .closest(settings.lineItem)
                .querySelector(settings.itemLinePrice);
              itemLinePrice != null &&
                (itemLinePrice.innerHTML = formatMoney(
                  item.line_price,
                  theme.currency.moneyFormat
                ));
            }
          });
          currencyConvert(".cart-section span.money");
        } else {
          let body = document.querySelector(settings.cartBody);
          body.innerHTML = theme.cartPage.empty || "";
        }
      } else if (settings.cartAction == "drawer") {
        await this2.getCartDrawer();
        let btnCheckout = this2.cartDrawerEl.querySelector(
          'button[name="checkout"]'
        );
        if (state.item_count > 0) {
          state.items.forEach((item) => {
            let itemExist = document.querySelector(
              `#${this2.settings.cartDrawer} [name="quantity"][data-item-key="${item.key}"]`
            );
            itemExist != null && itemExist.setAttribute("value", item.quantity);
          });
          let emptyDrawer = document.getElementById("cart-drawer-empty");
          emptyDrawer !== null && emptyDrawer.remove();
          this2.cartDrawerEl
            .querySelector(settings.removeAll)
            .classList.remove("hide");
          btnCheckout != null && btnCheckout.classList.remove("hide");
        } else {
          this2.cartDrawerEl.querySelector(
            settings.cartBody
          ).innerHTML = `<span id="cart-drawer-empty">${theme.cart.empty}<span>`;
          this2.cartDrawerEl
            .querySelector(settings.removeAll)
            .classList.add("hide");
          btnCheckout != null && btnCheckout.classList.add("hide");
        }
        currencyConvert(`#${settings.cartDrawer} .money`);
      }
      this2.updateCartState(state);
    },
    updateCartState: function (e) {
      let settings = this.settings;
      let waitingEl = document.querySelectorAll("." + settings.waitingClass);
      let errorItem = document.getElementById("lineCartError");
      Array.prototype.forEach.call(waitingEl, (i) => {
        AT_Cart.buttonLoading(i, false);
      });
      errorItem != null && errorItem.remove();
      if (e == null) {
        return;
      }
      let cartTotalItems = document.querySelectorAll(settings.cartCount);
      let cartTotalPrice = document.querySelectorAll(settings.total);
      Array.prototype.forEach.call(cartTotalItems, (i) => {
        i.innerHTML = e.item_count;
      });
      Array.prototype.forEach.call(cartTotalPrice, (i) => {
        i.innerHTML = formatMoney(e.total_price, theme.currency.moneyFormat);
      });
      currencyConvert(settings.total + " .money");
    },
    showNotify: async function (text, type = null) {
      let this2 = this;
      let settings = this2.settings;
      let msg = text || theme.cart.error_add_cart;
      let errorItem = document.getElementById("lineCartError");
      errorItem != null && errorItem.remove();
      if (this2.currentLine != null) {
        this2.currentLine.insertAdjacentHTML(
          "beforeend",
          `<span id="lineCartError">${msg}</span>`
        );
        this2.currentLine = null;
        return;
      }
      let dialog_notify = "dialogNotify";
      let content = document.getElementById(dialog_notify);
      if (content != null) {
        content.remove();
      }
      let getDialog = await fetch(
        `${theme.routes.search_url}?view=dialog.notification`
      );
      let dialogEl = await getDialog.text();
      document.body.insertAdjacentHTML("beforeend", dialogEl);
      content = document.getElementById(dialog_notify);
      if (type != null) {
        content.dataset.dialogType = type;
      }
      content = content.querySelector("[data-notify-content]");
      content.innerHTML = msg;
      arn_default.triggerDialog(dialog_notify);
      Array.prototype.forEach.call(
        document.querySelectorAll("." + settings.waitingClass),
        (i) => {
          AT_Cart.buttonLoading(i, false);
        }
      );
    },
  };
  var cart_default = AT_Cart;

  // node_modules/@shopify/theme-predictive-search/src/validate.js
  function validateQuery(query2) {
    var error2;
    if (query2 === null || query2 === void 0) {
      error2 = new TypeError("'query' is missing");
      error2.type = "argument";
      throw error2;
    }
    if (typeof query2 !== "string") {
      error2 = new TypeError("'query' is not a string");
      error2.type = "argument";
      throw error2;
    }
  }

  // node_modules/@shopify/theme-predictive-search/src/utilities/CustomError.js
  function GenericError() {
    var error2 = Error.call(this);
    error2.name = "Server error";
    error2.message = "Something went wrong on the server";
    error2.status = 500;
    return error2;
  }
  function NotFoundError(status) {
    var error2 = Error.call(this);
    error2.name = "Not found";
    error2.message = "Not found";
    error2.status = status;
    return error2;
  }
  function ServerError() {
    var error2 = Error.call(this);
    error2.name = "Server error";
    error2.message = "Something went wrong on the server";
    error2.status = 500;
    return error2;
  }
  function ContentTypeError(status) {
    var error2 = Error.call(this);
    error2.name = "Content-Type error";
    error2.message = "Content-Type was not provided or is of wrong type";
    error2.status = status;
    return error2;
  }
  function JsonParseError(status) {
    var error2 = Error.call(this);
    error2.name = "JSON parse error";
    error2.message = "JSON syntax error";
    error2.status = status;
    return error2;
  }
  function ThrottledError(status, name, message, retryAfter) {
    var error2 = Error.call(this);
    error2.name = name;
    error2.message = message;
    error2.status = status;
    error2.retryAfter = retryAfter;
    return error2;
  }
  function InvalidParameterError(status, name, message) {
    var error2 = Error.call(this);
    error2.name = name;
    error2.message = message;
    error2.status = status;
    return error2;
  }
  function ExpectationFailedError(status, name, message) {
    var error2 = Error.call(this);
    error2.name = name;
    error2.message = message;
    error2.status = status;
    return error2;
  }

  // node_modules/@shopify/theme-predictive-search/src/request.js
  function request2(searchPath, configParams, query2, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    var route = searchPath + "/suggest.json";
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        var contentType = xhr.getResponseHeader("Content-Type");
        if (xhr.status >= 500) {
          onError(new ServerError());
          return;
        }
        if (xhr.status === 404) {
          onError(new NotFoundError(xhr.status));
          return;
        }
        if (
          typeof contentType !== "string" ||
          contentType.toLowerCase().match("application/json") === null
        ) {
          onError(new ContentTypeError(xhr.status));
          return;
        }
        if (xhr.status === 417) {
          try {
            var invalidParameterJson = JSON.parse(xhr.responseText);
            onError(
              new InvalidParameterError(
                xhr.status,
                invalidParameterJson.message,
                invalidParameterJson.description
              )
            );
          } catch (error2) {
            onError(new JsonParseError(xhr.status));
          }
          return;
        }
        if (xhr.status === 422) {
          try {
            var expectationFailedJson = JSON.parse(xhr.responseText);
            onError(
              new ExpectationFailedError(
                xhr.status,
                expectationFailedJson.message,
                expectationFailedJson.description
              )
            );
          } catch (error2) {
            onError(new JsonParseError(xhr.status));
          }
          return;
        }
        if (xhr.status === 429) {
          try {
            var throttledJson = JSON.parse(xhr.responseText);
            onError(
              new ThrottledError(
                xhr.status,
                throttledJson.message,
                throttledJson.description,
                xhr.getResponseHeader("Retry-After")
              )
            );
          } catch (error2) {
            onError(new JsonParseError(xhr.status));
          }
          return;
        }
        if (xhr.status === 200) {
          try {
            var res = JSON.parse(xhr.responseText);
            res.query = query2;
            onSuccess(res);
          } catch (error2) {
            onError(new JsonParseError(xhr.status));
          }
          return;
        }
        try {
          var genericErrorJson = JSON.parse(xhr.responseText);
          onError(
            new GenericError(
              xhr.status,
              genericErrorJson.message,
              genericErrorJson.description
            )
          );
        } catch (error2) {
          onError(new JsonParseError(xhr.status));
        }
        return;
      }
    };
    xhr.open(
      "get",
      route + "?q=" + encodeURIComponent(query2) + "&" + configParams
    );
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send();
  }

  // node_modules/@shopify/theme-predictive-search/src/utilities/Cache.js
  function Cache(config) {
    this._store = {};
    this._keys = [];
    if (config && config.bucketSize) {
      this.bucketSize = config.bucketSize;
    } else {
      this.bucketSize = 20;
    }
  }
  Cache.prototype.set = function (key2, value) {
    if (this.count() >= this.bucketSize) {
      var deleteKey = this._keys.splice(0, 1);
      this.delete(deleteKey);
    }
    this._keys.push(key2);
    this._store[key2] = value;
    return this._store;
  };
  Cache.prototype.get = function (key2) {
    return this._store[key2];
  };
  Cache.prototype.has = function (key2) {
    return Boolean(this._store[key2]);
  };
  Cache.prototype.count = function () {
    return Object.keys(this._store).length;
  };
  Cache.prototype.delete = function (key2) {
    var exists = Boolean(this._store[key2]);
    delete this._store[key2];
    return exists && !this._store[key2];
  };

  // node_modules/@shopify/theme-predictive-search/src/utilities/Dispatcher.js
  function Dispatcher() {
    this.events = {};
  }
  Dispatcher.prototype.on = function (eventName, callback) {
    var event = this.events[eventName];
    if (!event) {
      event = new DispatcherEvent(eventName);
      this.events[eventName] = event;
    }
    event.registerCallback(callback);
  };
  Dispatcher.prototype.off = function (eventName, callback) {
    var event = this.events[eventName];
    if (event && event.callbacks.indexOf(callback) > -1) {
      event.unregisterCallback(callback);
      if (event.callbacks.length === 0) {
        delete this.events[eventName];
      }
    }
  };
  Dispatcher.prototype.dispatch = function (eventName, payload) {
    var event = this.events[eventName];
    if (event) {
      event.fire(payload);
    }
  };
  function DispatcherEvent(eventName) {
    this.eventName = eventName;
    this.callbacks = [];
  }
  DispatcherEvent.prototype.registerCallback = function (callback) {
    this.callbacks.push(callback);
  };
  DispatcherEvent.prototype.unregisterCallback = function (callback) {
    var index = this.callbacks.indexOf(callback);
    if (index > -1) {
      this.callbacks.splice(index, 1);
    }
  };
  DispatcherEvent.prototype.fire = function (payload) {
    var callbacks = this.callbacks.slice(0);
    callbacks.forEach(function (callback) {
      callback(payload);
    });
  };

  // node_modules/@shopify/theme-predictive-search/src/utilities/debounce.js
  function debounce(func, wait) {
    var timeout = null;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        timeout = null;
        func.apply(context, args);
      }, wait || 0);
    };
  }

  // node_modules/@shopify/theme-predictive-search/src/utilities/objectToQueryParams.js
  function objectToQueryParams(obj, parentKey) {
    var output = "";
    parentKey = parentKey || null;
    Object.keys(obj).forEach(function (key2) {
      var outputKey = key2 + "=";
      if (parentKey) {
        outputKey = parentKey + "[" + key2 + "]";
      }
      switch (trueTypeOf(obj[key2])) {
        case "object":
          output += objectToQueryParams(
            obj[key2],
            parentKey ? outputKey : key2
          );
          break;
        case "array":
          output += outputKey + "=" + obj[key2].join(",") + "&";
          break;
        default:
          if (parentKey) {
            outputKey += "=";
          }
          output += outputKey + encodeURIComponent(obj[key2]) + "&";
          break;
      }
    });
    return output;
  }
  function trueTypeOf(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
  }

  // node_modules/@shopify/theme-predictive-search/src/theme-predictive-search.js
  var DEBOUNCE_RATE = 10;
  var requestDebounced = debounce(request2, DEBOUNCE_RATE);
  function PredictiveSearch(config) {
    if (!config) {
      throw new TypeError("No config object was specified");
    }
    var configParameters = config;
    this._retryAfter = null;
    this._currentQuery = null;
    this.dispatcher = new Dispatcher();
    this.cache = new Cache({ bucketSize: 40 });
    this.searchPath = configParameters.search_path || "/search";
    if (configParameters.search_path) {
      delete configParameters["search_path"];
    }
    this.configParams = objectToQueryParams(configParameters);
  }
  PredictiveSearch.SEARCH_PATH = "/search";
  PredictiveSearch.TYPES = {
    PRODUCT: "product",
    PAGE: "page",
    ARTICLE: "article",
    COLLECTION: "collection",
  };
  PredictiveSearch.FIELDS = {
    AUTHOR: "author",
    BODY: "body",
    PRODUCT_TYPE: "product_type",
    TAG: "tag",
    TITLE: "title",
    VARIANTS_BARCODE: "variants.barcode",
    VARIANTS_SKU: "variants.sku",
    VARIANTS_TITLE: "variants.title",
    VENDOR: "vendor",
  };
  PredictiveSearch.UNAVAILABLE_PRODUCTS = {
    SHOW: "show",
    HIDE: "hide",
    LAST: "last",
  };
  PredictiveSearch.prototype.query = function query(query) {
    try {
      validateQuery(query);
    } catch (error2) {
      this.dispatcher.dispatch("error", error2);
      return;
    }
    if (query === "") {
      return this;
    }
    this._currentQuery = normalizeQuery(query);
    var cacheResult = this.cache.get(this._currentQuery);
    if (cacheResult) {
      this.dispatcher.dispatch("success", cacheResult);
      return this;
    }
    requestDebounced(
      this.searchPath,
      this.configParams,
      query,
      function (result) {
        this.cache.set(normalizeQuery(result.query), result);
        if (normalizeQuery(result.query) === this._currentQuery) {
          this._retryAfter = null;
          this.dispatcher.dispatch("success", result);
        }
      }.bind(this),
      function (error2) {
        if (error2.retryAfter) {
          this._retryAfter = error2.retryAfter;
        }
        this.dispatcher.dispatch("error", error2);
      }.bind(this)
    );
    return this;
  };
  PredictiveSearch.prototype.on = function on(eventName, callback) {
    this.dispatcher.on(eventName, callback);
    return this;
  };
  PredictiveSearch.prototype.off = function on2(eventName, callback) {
    this.dispatcher.off(eventName, callback);
    return this;
  };
  function normalizeQuery(query2) {
    if (typeof query2 !== "string") {
      return null;
    }
    return query2.trim().replace(" ", "-").toLowerCase();
  }

  // app/scripts/common/_search.js
  var RETURN_KEY_CODE = 13;
  var UP_ARROW_KEY_CODE = 38;
  var DOWN_ARROW_KEY_CODE = 40;
  var ESCAPE_KEY_CODE = 27;
  var BACKSPACE = 8;
  var existKeyCode = [
    RETURN_KEY_CODE,
    UP_ARROW_KEY_CODE,
    DOWN_ARROW_KEY_CODE,
    ESCAPE_KEY_CODE,
    BACKSPACE,
  ];
  var searchSettings = theme.search;
  var searchType =
    searchSettings.type == "product"
      ? ["product"]
      : ["product", "collection", "article", "page"];
  var predictiveSearch = new PredictiveSearch({
    search_path: theme.routes.search_url,
    resources: {
      type: searchType,
      limit: searchSettings.limit,
      options: {
        unavailable_products: searchSettings.unavailable_result,
      },
      fields: [
        PredictiveSearch.FIELDS.TITLE,
        PredictiveSearch.FIELDS.PRODUCT_TYPE,
        PredictiveSearch.FIELDS.VARIANTS_TITLE,
      ],
    },
  });
  predictiveSearch.on("success", async function (json) {
    let settings = AT_Search.settings;
    let results = json.resources.results;
    let resultsArray = [];
    let searchPath = theme.routes.search_url.replace(
      PredictiveSearch.SEARCH_PATH,
      ""
    );
    for (let i in results) {
      results[i].length > 0 &&
        results[i].forEach((item) => {
          resultsArray.push(
            new Promise((resolve, reject) => {
              let handle = item.handle;
              let url = `${searchPath}/${i}/${handle}?view=include.search-item`;
              if (i === "articles") {
                handle = item.url.slice(
                  0,
                  item.url.indexOf(item.handle) + item.handle.length
                );
                url = `${searchPath}${handle}?view=include.search-item`;
              }
              fetch(url)
                .then((resp) => resp.text())
                .then((resp) => resolve(resp))
                .catch((error2) => reject(error2));
            })
          );
        });
    }
    let result = await Promise.all(resultsArray);
    if (AT_Search.searchResultContainer != null) {
      AT_Search.showResults(result.join(""));
    }
  });
  predictiveSearch.on("error", function (error2) {
    console.error(error2);
  });
  var AT_Search = {
    settings: {
      resultLayout: "#searchResultLayout",
      searchDialog: "#searchModal",
      container: "[data-search-container]",
      resultTarget: "[data-search-result]",
      type: "[data-result-type]",
      item: ".search-result-item",
      title: "[data-item-title]",
      url: "[data-item-url]",
      image: "[data-item-image]",
      imageWrapper: ".result-item-image",
      price: "[data-item-price]",
      soldout: "[data-item-soldout]",
      submit: "[data-search-submit]",
    },
    refreshSearch: () => {
      let searchActive = document.querySelectorAll(
        ".search-is-active, .search-is-typing"
      );
      searchActive.length &&
        searchActive.forEach((e) => {
          e.classList.remove("search-is-active", "search-is-typing");
        });
    },
    handleEvent: function () {
      let settings = this.settings,
        searchDialog = document.querySelector(settings.searchDialog);
      tool_default.addEvent(document, "click", 'input[name="q"]', async (e) => {
        let searchElement = e.target;
        let searchContainer = searchElement.closest(settings.container);
        if (searchDialog.querySelector(".lazyload[data-include]") != null) {
          searchDialog.classList.add("lazyqueue-active");
          let isLazyLoad = await tool_default.activeLazyload(
            searchDialog,
            () => {
              searchDialog.classList.remove("lazyqueue-active");
            }
          );
        }
        AT_Search.refreshSearch();
        searchContainer.classList.add("search-is-active");
        searchElement.value.length
          ? searchContainer.classList.add("search-is-typing")
          : searchContainer.classList.remove("search-is-typing");
        if (
          tool_default.getWidthBrowser() < 992 &&
          !tool_default.isExist(searchElement.closest(settings.searchDialog))
        ) {
          arn_default.triggerDialog(settings.searchDialog);
        }
      });
      tool_default.addEvent(
        document,
        "keyup",
        'input[name="q"]',
        tool_default.debounceTime(500, (e) => {
          if (existKeyCode.some((k) => k == e.keyCode)) {
            return;
          }
          let searchElement = e.target;
          let searchContainer = searchElement.closest(settings.container);
          searchElement.value.length
            ? searchContainer.classList.add("search-is-typing")
            : searchContainer.classList.remove("search-is-typing");
          AT_Search.fetchData(searchElement, searchElement.value);
        })
      );
      tool_default.addEvent(document, "click", ".btn-search-clear", (e) => {
        e.preventDefault();
        let input = searchDialog.querySelector('input[name="q"]');
        let searchContainer = input.closest(settings.container);
        searchDialog.querySelector(settings.resultTarget).innerHTML = "";
        input.value = "";
        input.focus();
        searchContainer.classList.remove("search-is-typing");
      });
      tool_default.addEvent(document, "click", settings.submit, (e) => {
        e.preventDefault();
        let _container = e.target.closest(settings.container);
        if (_container == null) {
          return;
        }
        let form2 = _container.querySelector("form");
        form2 != null && form2.submit();
      });
      document.body.addEventListener("click", (e) => {
        let searchActive = document.querySelectorAll(".search-is-active");
        searchActive.length &&
          !tool_default.isExist(e.target.closest(".search-is-active")) &&
          searchActive.forEach((e2) => {
            e2.classList.remove("search-is-active");
          });
      });
    },
    fetchData: function (selector, value) {
      let this2 = this;
      let config = theme.search,
        settings = AT_Search.settings,
        container = selector.closest(settings.container),
        resultSelector = container.querySelector(settings.resultTarget);
      this2.searchResultContainer = resultSelector;
      if (!container.classList.contains("search-is-active")) {
        AT_Search.refreshSearch();
        container.classList.add("search-is-active");
      }
      container.classList.add("search-loading");
      if (selector.value.length == 0) {
        resultSelector.innerHTML = "";
        container.classList.remove("search-loading");
        return;
      }
      if (selector.value.length > 0 && selector.value.length < 2) {
        resultSelector.innerHTML = `<li class="result-notify">${config.notify_character}</li>`;
        container.classList.remove("search-loading");
        return;
      }
      let type =
          config.type == "product"
            ? ["product"]
            : ["product", "article", "page", "collection"],
        searchURL = theme.routes.search_url,
        url = `${searchURL}/suggest.json?q=${value}&resources[type]=${type}&resources[limit]=${config.limit}&resources[options][unavailable_products]=${config.unavailable_result}`;
      this.fetchSearch(selector.closest("form"));
    },
    fetchSearch(form2) {
      let formData = new FormData(form2);
      let url = new URLSearchParams(formData).toString();
      url = theme.routes.search_url + "?" + url;
      fetch(url + "&section_id=quick-search")
        .then((resp) => resp.text())
        .then((resp) => {
          let div = document.createElement("div");
          div.innerHTML = resp;
          console.log('resp', resp);
          this.showResults(div.querySelector(".shopify-section").innerHTML);
        });
    },
    showResults: function (resultHTML) {
      let settings = this.settings,
        container = this.searchResultContainer.closest(settings.container),
        resultSelector = container.querySelector(settings.resultTarget);
      if (resultHTML != "") {
        let lastestIem = document.querySelector(
          settings.resultLayout + " .search-redirect"
        );
        tool_default.isExist(lastestIem) &&
          (resultHTML += lastestIem.outerHTML);
        resultSelector.innerHTML = resultHTML;
        currency_default.convert(settings.resultTarget + " .money");
      } else {
        resultSelector.innerHTML = `<li class="result-notify">${searchSettings.no_result}</li>`;
      }
      container.classList.remove("search-loading");
    },
    init: function () {
      theme.template != "search" && this.handleEvent();
    },
  };
  var search_default = AT_Search;

  // app/scripts/common/_header.js
  var Header = {
    settings: {
      menuMobile: "#menuMobile",
      subClass: ".sub-opened",
      layerClass: ".mobile-layer",
      activeClass: "active",
    },
    init: function () {
      this.header = document.querySelector("#header-style");
      this.initEvents();
      this.mobileMenu_events();
      this.sticky();
      theme.live && this.initMobileBar();
    },
    initEvents: function () {
      let self2 = this,
        settings = self2.settings,
        menuDropdown = self2.header.querySelectorAll("li.nav-item");
      if (menuDropdown.length) {
        let header = self2.header.closest("header");
        menuDropdown.length &&
          menuDropdown.forEach((nav) => {
            nav.addEventListener("mouseenter", (e) => {
              if (nav.querySelector(".lazyload-include") == null) {
                return;
              }
              header.classList.add("nav-is-hover");
              nav.classList.add("is-hover");
            });
            nav.addEventListener("mouseleave", (e) => {
              header.classList.remove("nav-is-hover");
              nav.classList.remove("is-hover");
            });
          });
      }
      let sectionLink = document.querySelectorAll(
        'nav a[href^="#"]:not([href="#"])'
      );
      sectionLink.length &&
        sectionLink.forEach((item) => {
          item.addEventListener("click", (e) => {
            e.preventDefault();
            let href = e.currentTarget.getAttribute("href");
            let target = document.querySelector(href);
            target != null && tool_default.scrollTo(href);
          });
        });
      tool_default.addEvent(
        document.querySelector(settings.menuMobile),
        "click",
        "a",
        (e) => {
          let href = e.target.getAttribute("href");
          if (href == null || href == "#") {
            return;
          } else if (href.match(/^#/g) != null) {
            e.preventDefault();
            let target = document.querySelector(href);
            target != null && tool_default.scrollTo(href);
          }
        }
      );
    },
    setMinHeight: function () {
      let self2 = this,
        container = document.querySelectorAll(".header-block");
      container = [...container].filter((h) => h.offsetParent != null)[0];
      container = container.querySelector(":scope > div");
      let headerSticky = document.querySelector(".header-sticky");
      if (headerSticky.classList.contains("header-overlay")) {
        return;
      }
      container.parentNode.style.setProperty(
        "min-height",
        `${container.clientHeight}px`
      );
    },
    sticky: function () {
      let self2 = this;
      let headerSticky = document.querySelector(".header-sticky");
      if (headerSticky == null) {
        return;
      }
      let container = document.querySelectorAll(".header-block");
      container = [...container].filter((h) => h.offsetParent != null)[0];
      let position = container.offsetTop + 100;
      window.addEventListener("load", self2.setMinHeight);
      window.addEventListener("resize", self2.setMinHeight);
      window.addEventListener(
        "scroll",
        (e) => {
          let scrollTop = window.scrollY;
          if (scrollTop > position) {
            headerSticky.classList.add("active");
          } else {
            headerSticky.classList.remove("active");
          }
        },
        { passive: false }
      );
    },
    mobileBar: () => {
      let mobileBar = document.getElementById("mobile-bar"),
        scrollTop = window.scrollY + tool_default.getHeightBrowser(),
        bodyHeight = document.body.clientHeight;
      if (
        tool_default.getWidthBrowser() >= 992 ||
        mobileBar == null ||
        !JSON.parse(mobileBar.getAttribute("data-hide-bottom"))
      ) {
        return;
      }
      if (scrollTop > bodyHeight - 250) mobileBar.classList.add("d-none");
      else mobileBar.classList.remove("d-none");
    },
    initMobileBar: function () {
      let this2 = this;
      window.addEventListener(
        "scroll",
        () => {
          this2.mobileBar();
        },
        { passive: false }
      );
    },
    mobileMenu_events: function () {
      let self2 = this,
        settings = self2.settings;
      tool_default.addEvent(document, "click", "[data-submenu-link]", (e) => {
        let menuMobile = document.querySelector(settings.menuMobile);
        let _this = e.target,
          handle = _this.getAttribute("data-submenu-link"),
          target = menuMobile.querySelector(`[data-target="${handle}"]`);
        if (!tool_default.isExist(target)) {
          return;
        }
        let activeParent = _this.closest(
          `${settings.layerClass}.${settings.activeClass}:not(.main-layer)`
        );
        tool_default.isExist(activeParent) &&
          activeParent.classList.add(settings.subClass.replace(".", ""));
        target.classList.add(settings.activeClass);
        _this
          .closest(settings.layerClass)
          .classList.remove(settings.activeClass);
      });
      tool_default.addEvent(document, "click", ".mobile-layer-title", (e) => {
        let menuMobile = document.querySelector(settings.menuMobile);
        let _this = e.target;
        _this
          .closest(settings.layerClass)
          .classList.remove(settings.activeClass);
        let subOpening = menuMobile.querySelector(settings.subClass);
        if (tool_default.isExist(subOpening)) {
          subOpening.classList.remove(settings.subClass.replace(".", ""));
          subOpening.classList.add(settings.activeClass);
          return;
        }
        menuMobile
          .querySelector(settings.layerClass)
          .classList.add(settings.activeClass);
      });
    },
  };
  var header_default = Header;

  // app/scripts/arn-theme.js
  if (theme.product.review_type == "shopify") {
    (window.badgesCallback = function (a) {
      var e;
      return (
        (e = a.badges),
        SPR.$.map(SPR.badgeEls, function (a2) {
          var t;
          if (((t = SPR.$(a2).attr("data-id")), e[t] !== void 0))
            return (
              SPR.$(a2).replaceWith(e[t]),
              SPR.triggerEvent("spr:badge:loaded", { id: t })
            );
        })
      );
    }),
      (window.loadBadges = function () {
        var a, e;
        if (
          0 <
          (a = this.$.map(
            this.badgeEls,
            ((e = this),
            function (a2) {
              return e.$(a2).attr("data-id");
            })
          )).length
        )
          for (7, []; 0 < a.splice(0, 7).length; ) {
            let a2 = document.createElement("script");
            (a2.src = `${
              SPR.api_url
            }/reviews/badges?callback=badgesCallback&shop=${
              Shopify.shop
            }&${SPR.$.map(
              SPR.badgeEls,
              (a3) => "&product_ids[]=" + a3.getAttribute("data-id")
            )}`),
              a2.addEventListener("load", function () {
                this.remove();
              }),
              document.head.append(a2);
          }
      });
  }
  register("header", {
    onLoad: function () {
      header_default.init();
    },
    onBlockSelect: function (e) {
      let block = e.target;
      block.closest(".nav-dd, .nav-mm").classList.add("adm-active");
      block.closest("header").classList.add("nav-is-hover");
    },
    onBlockDeselect: function (e) {
      let block = e.target;
      block.closest(".nav-dd, .nav-mm").classList.remove("adm-active");
      block.closest("header").classList.remove("nav-is-hover");
    },
  });
  register("mobile-bar", {
    onLoad: function () {
      this.mobileBar = document.getElementById("mobile-bar");
      header_default.initMobileBar();
    },
    onSelect: function () {
      this.mobileBar.classList.add("d-block");
    },
    onDeselect: function () {
      this.mobileBar.classList.remove("d-block");
    },
    onBlockSelect: function () {
      this.mobileBar.classList.add("d-block");
    },
    onBlockDeselect: function () {
      this.mobileBar.classList.add("d-block");
    },
  });
  load("*");
  arn_default.init();
  currency_default.init();
  cart_default.init();
  search_default.init();
  theme.addEvent = function (parent, evt, selector, handler) {
    parent.addEventListener(
      evt,
      function (event) {
        if (event.target.matches(selector + ", " + selector + " *")) {
          handler.apply(event.target.closest(selector), arguments);
        }
      },
      false
    );
  };
  theme.addEvent(document, "click", ".swt-element", (e) => {
    let _this = e.target,
      swtContainer = _this.closest("[data-card-swatch]"),
      cardContainer = _this.closest("[data-product-card]"),
      handle = swtContainer.getAttribute("data-handle"),
      swtGroup = _this.closest(".swatch-container");
    let activeTarget = swtGroup.querySelector(".swt-element.active");
    activeTarget != null && activeTarget.classList.remove("active");
    _this.classList.add("active");
    let swtSelected = swtContainer.querySelectorAll(".swt-element.active");
    let valueSelect = [];
    swtSelected.forEach((v, i) => {
      v.classList.contains("active") &&
        valueSelect.push(v.getAttribute("data-value"));
    });
    let item_price = cardContainer.querySelector("[data-item-price]");
    let item_image = cardContainer.querySelector("[data-item-image]");
    let formSelect = cardContainer.querySelector('select[name="id"]');
    let btnCart = cardContainer.querySelector(".add-to-cart");
    fetch(
      `${theme.routes.all_products_collection_url}/products/${handle}.js`
    ).then((product) => {
      product.json().then((productJSON) => {
        let variant = productJSON.variants.filter(
          (i) => i.title == valueSelect.join(" / ")
        );
        !variant.length &&
          (variant = productJSON.variants.filter((i) =>
            i.title.includes(valueSelect.join(" / "))
          ));
        if (variant.length) {
          variant = variant[0];
          typeof Shopify.moneyFormat == "function" &&
            item_price != null &&
            (item_price.innerHTML = Shopify.moneyFormat(
              variant.price,
              theme.currency.moneyFormat
            ));
          variant.featured_media &&
            item_image != null &&
            (item_image.style.backgroundImage = `url('${variant.featured_media.preview_image.src}')`);
          if (formSelect != null) {
            formSelect.value = variant.id;
            if (btnCart != null) {
              if (variant.available) {
                btnCart.removeAttribute("disabled");
                btnCart.textContent = theme.cart.available;
                btnCart.classList.remove("soldout");
              } else {
                btnCart.setAttribute("disabled", "disabled");
                btnCart.textContent = theme.cart.soldout;
                btnCart.classList.add("soldout");
              }
            }
          }
        } else {
          btnCart != null && (btnCart.textContent = theme.cart.unavailable);
        }
      });
    });
  });
})();

$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });